// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/notebook/v1/document_service.proto (package chalk.notebook.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_chalk_auth_v1_audit } from "../../auth/v1/audit_pb";
import { file_chalk_auth_v1_permissions } from "../../auth/v1/permissions_pb";
import type { NotebookCell, NotebookDocument, NotebookDocumentRevision, NotebookRunScope, NotebookSecret, NotebookSecretValue, NotebookShareLink } from "./document_pb";
import { file_chalk_notebook_v1_document } from "./document_pb";
import type { InstalledPackage, KernelBuildInfo } from "./kernel_service_pb";
import { file_chalk_notebook_v1_kernel_service } from "./kernel_service_pb";
import type { NotebookCellResult, NotebookCellRunHistoryEntry, NotebookRunEvent, NotebookRunStatus, NotebookRunSummary } from "./runtime_pb";
import { file_chalk_notebook_v1_runtime } from "./runtime_pb";
import type { SecretConfigValue } from "../../server/v1/environment_secrets_pb";
import { file_chalk_server_v1_environment_secrets } from "../../server/v1/environment_secrets_pb";
import type { Duration, FieldMask, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_duration, file_google_protobuf_field_mask, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/notebook/v1/document_service.proto.
 */
export const file_chalk_notebook_v1_document_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chalk_auth_v1_audit, file_chalk_auth_v1_permissions, file_chalk_notebook_v1_document, file_chalk_notebook_v1_kernel_service, file_chalk_notebook_v1_runtime, file_chalk_server_v1_environment_secrets, file_google_protobuf_duration, file_google_protobuf_field_mask, file_google_protobuf_timestamp]);

/**
 * @generated from message chalk.notebook.v1.CreateNotebookDocumentRequest
 */
export type CreateNotebookDocumentRequest = Message<"chalk.notebook.v1.CreateNotebookDocumentRequest"> & {
  /**
   * @generated from field: chalk.notebook.v1.NotebookDocument document = 1;
   */
  document?: NotebookDocument;

  /**
   * @generated from field: optional string client_request_id = 2;
   */
  clientRequestId?: string;
};

/**
 * Describes the message chalk.notebook.v1.CreateNotebookDocumentRequest.
 * Use `create(CreateNotebookDocumentRequestSchema)` to create a new message.
 */
export const CreateNotebookDocumentRequestSchema: GenMessage<CreateNotebookDocumentRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 0);

/**
 * @generated from message chalk.notebook.v1.CreateNotebookDocumentResponse
 */
export type CreateNotebookDocumentResponse = Message<"chalk.notebook.v1.CreateNotebookDocumentResponse"> & {
  /**
   * @generated from field: chalk.notebook.v1.NotebookDocument document = 1;
   */
  document?: NotebookDocument;
};

/**
 * Describes the message chalk.notebook.v1.CreateNotebookDocumentResponse.
 * Use `create(CreateNotebookDocumentResponseSchema)` to create a new message.
 */
export const CreateNotebookDocumentResponseSchema: GenMessage<CreateNotebookDocumentResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 1);

/**
 * @generated from message chalk.notebook.v1.GetNotebookDocumentRequest
 */
export type GetNotebookDocumentRequest = Message<"chalk.notebook.v1.GetNotebookDocumentRequest"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;

  /**
   * When set, returns the persisted historical revision instead of the
   * current document.
   *
   * @generated from field: optional string revision_id = 2;
   */
  revisionId?: string;
};

/**
 * Describes the message chalk.notebook.v1.GetNotebookDocumentRequest.
 * Use `create(GetNotebookDocumentRequestSchema)` to create a new message.
 */
export const GetNotebookDocumentRequestSchema: GenMessage<GetNotebookDocumentRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 2);

/**
 * @generated from message chalk.notebook.v1.GetNotebookDocumentResponse
 */
export type GetNotebookDocumentResponse = Message<"chalk.notebook.v1.GetNotebookDocumentResponse"> & {
  /**
   * @generated from field: chalk.notebook.v1.NotebookDocument document = 1;
   */
  document?: NotebookDocument;
};

/**
 * Describes the message chalk.notebook.v1.GetNotebookDocumentResponse.
 * Use `create(GetNotebookDocumentResponseSchema)` to create a new message.
 */
export const GetNotebookDocumentResponseSchema: GenMessage<GetNotebookDocumentResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 3);

/**
 * @generated from message chalk.notebook.v1.ListNotebookDocumentsRequest
 */
export type ListNotebookDocumentsRequest = Message<"chalk.notebook.v1.ListNotebookDocumentsRequest"> & {
  /**
   * @generated from field: repeated string statuses = 3 [deprecated = true];
   * @deprecated
   */
  statuses: string[];

  /**
   * @generated from field: repeated string categories = 4 [deprecated = true];
   * @deprecated
   */
  categories: string[];

  /**
   * @generated from field: optional string cursor = 5;
   */
  cursor?: string;

  /**
   * @generated from field: optional int32 limit = 6;
   */
  limit?: number;

  /**
   * When false (default), archived notebooks (archived_at set) are excluded
   * from the results. Set true to include archived notebooks.
   *
   * @generated from field: bool include_archived = 7 [deprecated = true];
   * @deprecated
   */
  includeArchived: boolean;

  /**
   * Case-insensitive substring match against the notebook title.
   *
   * @generated from field: optional string search = 8 [deprecated = true];
   * @deprecated
   */
  search?: string;

  /**
   * @generated from field: repeated string created_by = 9 [deprecated = true];
   * @deprecated
   */
  createdBy: string[];

  /**
   * @generated from field: repeated string updated_by = 10 [deprecated = true];
   * @deprecated
   */
  updatedBy: string[];

  /**
   * @generated from field: chalk.notebook.v1.NotebookDocumentSortColumn sort_column = 11;
   */
  sortColumn: NotebookDocumentSortColumn;

  /**
   * @generated from field: chalk.notebook.v1.NotebookDocumentSortOrder sort_order = 12;
   */
  sortOrder: NotebookDocumentSortOrder;

  /**
   * @generated from field: chalk.notebook.v1.ListNotebookDocumentsFilters filters = 13;
   */
  filters?: ListNotebookDocumentsFilters;
};

/**
 * Describes the message chalk.notebook.v1.ListNotebookDocumentsRequest.
 * Use `create(ListNotebookDocumentsRequestSchema)` to create a new message.
 */
export const ListNotebookDocumentsRequestSchema: GenMessage<ListNotebookDocumentsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 4);

/**
 * @generated from message chalk.notebook.v1.ListNotebookDocumentsResponse
 */
export type ListNotebookDocumentsResponse = Message<"chalk.notebook.v1.ListNotebookDocumentsResponse"> & {
  /**
   * @generated from field: repeated chalk.notebook.v1.NotebookDocument documents = 1;
   */
  documents: NotebookDocument[];

  /**
   * @generated from field: optional string next_cursor = 2;
   */
  nextCursor?: string;
};

/**
 * Describes the message chalk.notebook.v1.ListNotebookDocumentsResponse.
 * Use `create(ListNotebookDocumentsResponseSchema)` to create a new message.
 */
export const ListNotebookDocumentsResponseSchema: GenMessage<ListNotebookDocumentsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 5);

/**
 * @generated from message chalk.notebook.v1.UpdateNotebookDocumentRequest
 */
export type UpdateNotebookDocumentRequest = Message<"chalk.notebook.v1.UpdateNotebookDocumentRequest"> & {
  /**
   * @generated from field: chalk.notebook.v1.NotebookDocument document = 1;
   */
  document?: NotebookDocument;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 2;
   */
  updateMask?: FieldMask;

  /**
   * @generated from field: optional string expected_revision_id = 3;
   */
  expectedRevisionId?: string;
};

/**
 * Describes the message chalk.notebook.v1.UpdateNotebookDocumentRequest.
 * Use `create(UpdateNotebookDocumentRequestSchema)` to create a new message.
 */
export const UpdateNotebookDocumentRequestSchema: GenMessage<UpdateNotebookDocumentRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 6);

/**
 * @generated from message chalk.notebook.v1.UpdateNotebookDocumentResponse
 */
export type UpdateNotebookDocumentResponse = Message<"chalk.notebook.v1.UpdateNotebookDocumentResponse"> & {
  /**
   * @generated from field: chalk.notebook.v1.NotebookDocument document = 1;
   */
  document?: NotebookDocument;
};

/**
 * Describes the message chalk.notebook.v1.UpdateNotebookDocumentResponse.
 * Use `create(UpdateNotebookDocumentResponseSchema)` to create a new message.
 */
export const UpdateNotebookDocumentResponseSchema: GenMessage<UpdateNotebookDocumentResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 7);

/**
 * @generated from message chalk.notebook.v1.DeleteNotebookDocumentRequest
 */
export type DeleteNotebookDocumentRequest = Message<"chalk.notebook.v1.DeleteNotebookDocumentRequest"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;

  /**
   * @generated from field: optional string expected_revision_id = 2;
   */
  expectedRevisionId?: string;
};

/**
 * Describes the message chalk.notebook.v1.DeleteNotebookDocumentRequest.
 * Use `create(DeleteNotebookDocumentRequestSchema)` to create a new message.
 */
export const DeleteNotebookDocumentRequestSchema: GenMessage<DeleteNotebookDocumentRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 8);

/**
 * @generated from message chalk.notebook.v1.DeleteNotebookDocumentResponse
 */
export type DeleteNotebookDocumentResponse = Message<"chalk.notebook.v1.DeleteNotebookDocumentResponse"> & {
};

/**
 * Describes the message chalk.notebook.v1.DeleteNotebookDocumentResponse.
 * Use `create(DeleteNotebookDocumentResponseSchema)` to create a new message.
 */
export const DeleteNotebookDocumentResponseSchema: GenMessage<DeleteNotebookDocumentResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 9);

/**
 * @generated from message chalk.notebook.v1.EnsureNotebookAppRequest
 */
export type EnsureNotebookAppRequest = Message<"chalk.notebook.v1.EnsureNotebookAppRequest"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;
};

/**
 * Describes the message chalk.notebook.v1.EnsureNotebookAppRequest.
 * Use `create(EnsureNotebookAppRequestSchema)` to create a new message.
 */
export const EnsureNotebookAppRequestSchema: GenMessage<EnsureNotebookAppRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 10);

/**
 * @generated from message chalk.notebook.v1.EnsureNotebookAppResponse
 */
export type EnsureNotebookAppResponse = Message<"chalk.notebook.v1.EnsureNotebookAppResponse"> & {
  /**
   * Id of the live app-layout dashboard (owner_type="notebook",
   * owner_id=notebook_id); also surfaced as
   * NotebookDocument.app_dashboard_id once set.
   *
   * @generated from field: string dashboard_id = 1;
   */
  dashboardId: string;
};

/**
 * Describes the message chalk.notebook.v1.EnsureNotebookAppResponse.
 * Use `create(EnsureNotebookAppResponseSchema)` to create a new message.
 */
export const EnsureNotebookAppResponseSchema: GenMessage<EnsureNotebookAppResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 11);

/**
 * @generated from message chalk.notebook.v1.SetNotebookArchivedRequest
 */
export type SetNotebookArchivedRequest = Message<"chalk.notebook.v1.SetNotebookArchivedRequest"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;

  /**
   * @generated from field: bool archived = 2;
   */
  archived: boolean;

  /**
   * @generated from field: string expected_revision_id = 3;
   */
  expectedRevisionId: string;
};

/**
 * Describes the message chalk.notebook.v1.SetNotebookArchivedRequest.
 * Use `create(SetNotebookArchivedRequestSchema)` to create a new message.
 */
export const SetNotebookArchivedRequestSchema: GenMessage<SetNotebookArchivedRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 12);

/**
 * @generated from message chalk.notebook.v1.SetNotebookArchivedResponse
 */
export type SetNotebookArchivedResponse = Message<"chalk.notebook.v1.SetNotebookArchivedResponse"> & {
  /**
   * @generated from field: chalk.notebook.v1.NotebookDocument notebook = 1;
   */
  notebook?: NotebookDocument;
};

/**
 * Describes the message chalk.notebook.v1.SetNotebookArchivedResponse.
 * Use `create(SetNotebookArchivedResponseSchema)` to create a new message.
 */
export const SetNotebookArchivedResponseSchema: GenMessage<SetNotebookArchivedResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 13);

/**
 * @generated from message chalk.notebook.v1.AddNotebookCellRequest
 */
export type AddNotebookCellRequest = Message<"chalk.notebook.v1.AddNotebookCellRequest"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;

  /**
   * @generated from field: chalk.notebook.v1.NotebookCell cell = 2;
   */
  cell?: NotebookCell;

  /**
   * @generated from field: optional string before_cell_id = 3;
   */
  beforeCellId?: string;

  /**
   * @generated from field: optional string after_cell_id = 4;
   */
  afterCellId?: string;

  /**
   * @generated from field: optional string expected_revision_id = 5;
   */
  expectedRevisionId?: string;
};

/**
 * Describes the message chalk.notebook.v1.AddNotebookCellRequest.
 * Use `create(AddNotebookCellRequestSchema)` to create a new message.
 */
export const AddNotebookCellRequestSchema: GenMessage<AddNotebookCellRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 14);

/**
 * @generated from message chalk.notebook.v1.AddNotebookCellResponse
 */
export type AddNotebookCellResponse = Message<"chalk.notebook.v1.AddNotebookCellResponse"> & {
  /**
   * @generated from field: chalk.notebook.v1.NotebookDocument document = 1;
   */
  document?: NotebookDocument;

  /**
   * @generated from field: chalk.notebook.v1.NotebookCell cell = 2;
   */
  cell?: NotebookCell;
};

/**
 * Describes the message chalk.notebook.v1.AddNotebookCellResponse.
 * Use `create(AddNotebookCellResponseSchema)` to create a new message.
 */
export const AddNotebookCellResponseSchema: GenMessage<AddNotebookCellResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 15);

/**
 * @generated from message chalk.notebook.v1.WatchNotebookRequest
 */
export type WatchNotebookRequest = Message<"chalk.notebook.v1.WatchNotebookRequest"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;
};

/**
 * Describes the message chalk.notebook.v1.WatchNotebookRequest.
 * Use `create(WatchNotebookRequestSchema)` to create a new message.
 */
export const WatchNotebookRequestSchema: GenMessage<WatchNotebookRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 16);

/**
 * @generated from message chalk.notebook.v1.WatchNotebookEvent
 */
export type WatchNotebookEvent = Message<"chalk.notebook.v1.WatchNotebookEvent"> & {
  /**
   * @generated from field: chalk.notebook.v1.NotebookWatchEventType event_type = 1;
   */
  eventType: NotebookWatchEventType;

  /**
   * The document's revision as of this event, for DOCUMENT_CHANGED. Doubles as
   * the client's echo-suppression key: an event naming the revision the client
   * already holds describes the client's own write.
   *
   * @generated from field: string revision_id = 2;
   */
  revisionId: string;

  /**
   * Set for RUN_STATE_CHANGED.
   *
   * @generated from field: string run_id = 3;
   */
  runId: string;

  /**
   * The run's status as of this event, for RUN_STATE_CHANGED.
   *
   * @generated from field: chalk.notebook.v1.NotebookRunStatus run_status = 4;
   */
  runStatus: NotebookRunStatus;

  /**
   * @generated from field: google.protobuf.Timestamp observed_at = 5;
   */
  observedAt?: Timestamp;
};

/**
 * Describes the message chalk.notebook.v1.WatchNotebookEvent.
 * Use `create(WatchNotebookEventSchema)` to create a new message.
 */
export const WatchNotebookEventSchema: GenMessage<WatchNotebookEvent> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 17);

/**
 * @generated from message chalk.notebook.v1.WatchNotebookResponse
 */
export type WatchNotebookResponse = Message<"chalk.notebook.v1.WatchNotebookResponse"> & {
  /**
   * @generated from field: chalk.notebook.v1.WatchNotebookEvent event = 1;
   */
  event?: WatchNotebookEvent;
};

/**
 * Describes the message chalk.notebook.v1.WatchNotebookResponse.
 * Use `create(WatchNotebookResponseSchema)` to create a new message.
 */
export const WatchNotebookResponseSchema: GenMessage<WatchNotebookResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 18);

/**
 * @generated from message chalk.notebook.v1.UpdateNotebookCellRequest
 */
export type UpdateNotebookCellRequest = Message<"chalk.notebook.v1.UpdateNotebookCellRequest"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;

  /**
   * @generated from field: chalk.notebook.v1.NotebookCell cell = 2;
   */
  cell?: NotebookCell;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 3;
   */
  updateMask?: FieldMask;

  /**
   * @generated from field: optional string expected_revision_id = 4;
   */
  expectedRevisionId?: string;

  /**
   * Cell-granular optimistic concurrency: the cell revision_id this patch was
   * composed against. Prefer this over expected_revision_id for content edits —
   * it only conflicts when this cell itself changed, so a concurrent edit to a
   * different cell (another tab, another user, an agent) merges instead of
   * failing. A mismatch, or a cell deleted underneath the caller, is a
   * FailedPrecondition.
   *
   * @generated from field: optional string expected_cell_revision_id = 5;
   */
  expectedCellRevisionId?: string;

  /**
   * @generated from field: chalk.notebook.v1.NotebookCellConflictResolution on_cell_conflict = 6;
   */
  onCellConflict: NotebookCellConflictResolution;
};

/**
 * Describes the message chalk.notebook.v1.UpdateNotebookCellRequest.
 * Use `create(UpdateNotebookCellRequestSchema)` to create a new message.
 */
export const UpdateNotebookCellRequestSchema: GenMessage<UpdateNotebookCellRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 19);

/**
 * @generated from message chalk.notebook.v1.UpdateNotebookCellResponse
 */
export type UpdateNotebookCellResponse = Message<"chalk.notebook.v1.UpdateNotebookCellResponse"> & {
  /**
   * @generated from field: chalk.notebook.v1.NotebookDocument document = 1;
   */
  document?: NotebookDocument;

  /**
   * @generated from field: chalk.notebook.v1.NotebookCell cell = 2;
   */
  cell?: NotebookCell;

  /**
   * Set when on_cell_conflict was MERGE and this cell's source was three-way
   * merged, so `cell` is not verbatim what the caller sent. A client holding an
   * editable buffer must adopt the returned source.
   *
   * @generated from field: bool merged = 3;
   */
  merged: boolean;
};

/**
 * Describes the message chalk.notebook.v1.UpdateNotebookCellResponse.
 * Use `create(UpdateNotebookCellResponseSchema)` to create a new message.
 */
export const UpdateNotebookCellResponseSchema: GenMessage<UpdateNotebookCellResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 20);

/**
 * @generated from message chalk.notebook.v1.DeleteNotebookCellRequest
 */
export type DeleteNotebookCellRequest = Message<"chalk.notebook.v1.DeleteNotebookCellRequest"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;

  /**
   * @generated from field: string cell_id = 2;
   */
  cellId: string;

  /**
   * @generated from field: optional string expected_revision_id = 3;
   */
  expectedRevisionId?: string;
};

/**
 * Describes the message chalk.notebook.v1.DeleteNotebookCellRequest.
 * Use `create(DeleteNotebookCellRequestSchema)` to create a new message.
 */
export const DeleteNotebookCellRequestSchema: GenMessage<DeleteNotebookCellRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 21);

/**
 * @generated from message chalk.notebook.v1.DeleteNotebookCellResponse
 */
export type DeleteNotebookCellResponse = Message<"chalk.notebook.v1.DeleteNotebookCellResponse"> & {
  /**
   * @generated from field: chalk.notebook.v1.NotebookDocument document = 1;
   */
  document?: NotebookDocument;
};

/**
 * Describes the message chalk.notebook.v1.DeleteNotebookCellResponse.
 * Use `create(DeleteNotebookCellResponseSchema)` to create a new message.
 */
export const DeleteNotebookCellResponseSchema: GenMessage<DeleteNotebookCellResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 22);

/**
 * @generated from message chalk.notebook.v1.MoveNotebookCellRequest
 */
export type MoveNotebookCellRequest = Message<"chalk.notebook.v1.MoveNotebookCellRequest"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;

  /**
   * @generated from field: string cell_id = 2;
   */
  cellId: string;

  /**
   * @generated from field: optional string before_cell_id = 3;
   */
  beforeCellId?: string;

  /**
   * @generated from field: optional string after_cell_id = 4;
   */
  afterCellId?: string;

  /**
   * @generated from field: optional string expected_revision_id = 5;
   */
  expectedRevisionId?: string;
};

/**
 * Describes the message chalk.notebook.v1.MoveNotebookCellRequest.
 * Use `create(MoveNotebookCellRequestSchema)` to create a new message.
 */
export const MoveNotebookCellRequestSchema: GenMessage<MoveNotebookCellRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 23);

/**
 * @generated from message chalk.notebook.v1.MoveNotebookCellResponse
 */
export type MoveNotebookCellResponse = Message<"chalk.notebook.v1.MoveNotebookCellResponse"> & {
  /**
   * @generated from field: chalk.notebook.v1.NotebookDocument document = 1;
   */
  document?: NotebookDocument;
};

/**
 * Describes the message chalk.notebook.v1.MoveNotebookCellResponse.
 * Use `create(MoveNotebookCellResponseSchema)` to create a new message.
 */
export const MoveNotebookCellResponseSchema: GenMessage<MoveNotebookCellResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 24);

/**
 * @generated from message chalk.notebook.v1.BatchUpdateNotebookCellsRequest
 */
export type BatchUpdateNotebookCellsRequest = Message<"chalk.notebook.v1.BatchUpdateNotebookCellsRequest"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;

  /**
   * @generated from field: repeated chalk.notebook.v1.NotebookCell cells = 2;
   */
  cells: NotebookCell[];

  /**
   * @generated from field: repeated string deleted_cell_ids = 3;
   */
  deletedCellIds: string[];

  /**
   * @generated from field: repeated string cell_order = 4;
   */
  cellOrder: string[];

  /**
   * @generated from field: optional string expected_revision_id = 5;
   */
  expectedRevisionId?: string;

  /**
   * Cell-granular optimistic concurrency: cell_id -> the cell revision_id the
   * caller composed its patch against. See
   * UpdateNotebookCellRequest.expected_cell_revision_id. Entries are only
   * required for cells the caller read first; omit an entry to write a cell
   * unconditionally. Validation is all-or-nothing: if any listed cell moved on,
   * the whole batch fails with FailedPrecondition and nothing is written, so a
   * caller's saved baseline never diverges from what was persisted.
   *
   * @generated from field: map<string, string> expected_cell_revision_ids = 6;
   */
  expectedCellRevisionIds: { [key: string]: string };

  /**
   * @generated from field: chalk.notebook.v1.NotebookCellConflictResolution on_cell_conflict = 7;
   */
  onCellConflict: NotebookCellConflictResolution;
};

/**
 * Describes the message chalk.notebook.v1.BatchUpdateNotebookCellsRequest.
 * Use `create(BatchUpdateNotebookCellsRequestSchema)` to create a new message.
 */
export const BatchUpdateNotebookCellsRequestSchema: GenMessage<BatchUpdateNotebookCellsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 25);

/**
 * @generated from message chalk.notebook.v1.BatchUpdateNotebookCellsResponse
 */
export type BatchUpdateNotebookCellsResponse = Message<"chalk.notebook.v1.BatchUpdateNotebookCellsResponse"> & {
  /**
   * @generated from field: chalk.notebook.v1.NotebookDocument document = 1;
   */
  document?: NotebookDocument;

  /**
   * Cells whose source was three-way merged because another writer had edited
   * them first. Their persisted content is not verbatim what the caller sent, so
   * a client holding editable buffers must adopt the returned source for these.
   *
   * @generated from field: repeated string merged_cell_ids = 2;
   */
  mergedCellIds: string[];
};

/**
 * Describes the message chalk.notebook.v1.BatchUpdateNotebookCellsResponse.
 * Use `create(BatchUpdateNotebookCellsResponseSchema)` to create a new message.
 */
export const BatchUpdateNotebookCellsResponseSchema: GenMessage<BatchUpdateNotebookCellsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 26);

/**
 * @generated from message chalk.notebook.v1.StartNotebookRunRequest
 */
export type StartNotebookRunRequest = Message<"chalk.notebook.v1.StartNotebookRunRequest"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;

  /**
   * @generated from field: repeated string cell_ids = 2;
   */
  cellIds: string[];

  /**
   * @generated from field: chalk.notebook.v1.NotebookRunScope run_scope = 3;
   */
  runScope: NotebookRunScope;

  /**
   * @generated from field: optional string runtime_notebook_id = 4;
   */
  runtimeNotebookId?: string;

  /**
   * @generated from field: optional string expected_revision_id = 5;
   */
  expectedRevisionId?: string;

  /**
   * @generated from field: bool clear_previous_outputs = 6;
   */
  clearPreviousOutputs: boolean;

  /**
   * Run-level staleness CAP for SQL result caching, not a default:
   * effective = min(this, the value resolved from cell/notebook/env/team
   * settings). 0 = "run without cached results" (single cell or run-all).
   * Absent = no cap; the settings chain applies.
   *
   * @generated from field: optional google.protobuf.Duration max_staleness = 7;
   */
  maxStaleness?: Duration;
};

/**
 * Describes the message chalk.notebook.v1.StartNotebookRunRequest.
 * Use `create(StartNotebookRunRequestSchema)` to create a new message.
 */
export const StartNotebookRunRequestSchema: GenMessage<StartNotebookRunRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 27);

/**
 * Summary of one cell run scheduled by StartNotebookRun, in execution order.
 *
 * @generated from message chalk.notebook.v1.NotebookRunPlanEntry
 */
export type NotebookRunPlanEntry = Message<"chalk.notebook.v1.NotebookRunPlanEntry"> & {
  /**
   * @generated from field: string cell_id = 1;
   */
  cellId: string;

  /**
   * @generated from field: string cell_run_id = 2;
   */
  cellRunId: string;
};

/**
 * Describes the message chalk.notebook.v1.NotebookRunPlanEntry.
 * Use `create(NotebookRunPlanEntrySchema)` to create a new message.
 */
export const NotebookRunPlanEntrySchema: GenMessage<NotebookRunPlanEntry> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 28);

/**
 * @generated from message chalk.notebook.v1.StartNotebookRunResponse
 */
export type StartNotebookRunResponse = Message<"chalk.notebook.v1.StartNotebookRunResponse"> & {
  /**
   * @generated from field: string run_id = 1;
   */
  runId: string;

  /**
   * Cells that will execute, in order, after run-scope expansion.
   *
   * @generated from field: repeated chalk.notebook.v1.NotebookRunPlanEntry plan = 2;
   */
  plan: NotebookRunPlanEntry[];
};

/**
 * Describes the message chalk.notebook.v1.StartNotebookRunResponse.
 * Use `create(StartNotebookRunResponseSchema)` to create a new message.
 */
export const StartNotebookRunResponseSchema: GenMessage<StartNotebookRunResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 29);

/**
 * @generated from message chalk.notebook.v1.WatchNotebookRunRequest
 */
export type WatchNotebookRunRequest = Message<"chalk.notebook.v1.WatchNotebookRunRequest"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;

  /**
   * @generated from field: string run_id = 2;
   */
  runId: string;

  /**
   * Resume point: output chunks with run_sequence <= after_sequence are not
   * replayed. Lifecycle events (RUN_STARTED, CELL_QUEUED/STARTED/FINISHED,
   * RUN_FINISHED) are always replayed and must be handled idempotently.
   *
   * @generated from field: optional int64 after_sequence = 3;
   */
  afterSequence?: bigint;
};

/**
 * Describes the message chalk.notebook.v1.WatchNotebookRunRequest.
 * Use `create(WatchNotebookRunRequestSchema)` to create a new message.
 */
export const WatchNotebookRunRequestSchema: GenMessage<WatchNotebookRunRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 30);

/**
 * @generated from message chalk.notebook.v1.WatchNotebookRunResponse
 */
export type WatchNotebookRunResponse = Message<"chalk.notebook.v1.WatchNotebookRunResponse"> & {
  /**
   * @generated from field: chalk.notebook.v1.NotebookRunEvent event = 1;
   */
  event?: NotebookRunEvent;
};

/**
 * Describes the message chalk.notebook.v1.WatchNotebookRunResponse.
 * Use `create(WatchNotebookRunResponseSchema)` to create a new message.
 */
export const WatchNotebookRunResponseSchema: GenMessage<WatchNotebookRunResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 31);

/**
 * @generated from message chalk.notebook.v1.InterruptNotebookRunRequest
 */
export type InterruptNotebookRunRequest = Message<"chalk.notebook.v1.InterruptNotebookRunRequest"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;

  /**
   * @generated from field: string run_id = 2;
   */
  runId: string;

  /**
   * @generated from field: optional string runtime_notebook_id = 3;
   */
  runtimeNotebookId?: string;
};

/**
 * Describes the message chalk.notebook.v1.InterruptNotebookRunRequest.
 * Use `create(InterruptNotebookRunRequestSchema)` to create a new message.
 */
export const InterruptNotebookRunRequestSchema: GenMessage<InterruptNotebookRunRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 32);

/**
 * @generated from message chalk.notebook.v1.InterruptNotebookRunResponse
 */
export type InterruptNotebookRunResponse = Message<"chalk.notebook.v1.InterruptNotebookRunResponse"> & {
  /**
   * @generated from field: chalk.notebook.v1.NotebookInterruptOutcome outcome = 1;
   */
  outcome: NotebookInterruptOutcome;
};

/**
 * Describes the message chalk.notebook.v1.InterruptNotebookRunResponse.
 * Use `create(InterruptNotebookRunResponseSchema)` to create a new message.
 */
export const InterruptNotebookRunResponseSchema: GenMessage<InterruptNotebookRunResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 33);

/**
 * @generated from message chalk.notebook.v1.ListNotebookCellResultsRequest
 */
export type ListNotebookCellResultsRequest = Message<"chalk.notebook.v1.ListNotebookCellResultsRequest"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;

  /**
   * @generated from field: repeated string cell_ids = 2;
   */
  cellIds: string[];
};

/**
 * Describes the message chalk.notebook.v1.ListNotebookCellResultsRequest.
 * Use `create(ListNotebookCellResultsRequestSchema)` to create a new message.
 */
export const ListNotebookCellResultsRequestSchema: GenMessage<ListNotebookCellResultsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 34);

/**
 * @generated from message chalk.notebook.v1.ListNotebookCellResultsResponse
 */
export type ListNotebookCellResultsResponse = Message<"chalk.notebook.v1.ListNotebookCellResultsResponse"> & {
  /**
   * @generated from field: repeated chalk.notebook.v1.NotebookCellResult results = 1;
   */
  results: NotebookCellResult[];
};

/**
 * Describes the message chalk.notebook.v1.ListNotebookCellResultsResponse.
 * Use `create(ListNotebookCellResultsResponseSchema)` to create a new message.
 */
export const ListNotebookCellResultsResponseSchema: GenMessage<ListNotebookCellResultsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 35);

/**
 * @generated from message chalk.notebook.v1.ListNotebookCellRunHistoryRequest
 */
export type ListNotebookCellRunHistoryRequest = Message<"chalk.notebook.v1.ListNotebookCellRunHistoryRequest"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;

  /**
   * @generated from field: repeated string cell_ids = 2;
   */
  cellIds: string[];

  /**
   * @generated from field: optional int32 limit = 3;
   */
  limit?: number;

  /**
   * @generated from field: optional string cursor = 4;
   */
  cursor?: string;
};

/**
 * Describes the message chalk.notebook.v1.ListNotebookCellRunHistoryRequest.
 * Use `create(ListNotebookCellRunHistoryRequestSchema)` to create a new message.
 */
export const ListNotebookCellRunHistoryRequestSchema: GenMessage<ListNotebookCellRunHistoryRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 36);

/**
 * @generated from message chalk.notebook.v1.ListNotebookCellRunHistoryResponse
 */
export type ListNotebookCellRunHistoryResponse = Message<"chalk.notebook.v1.ListNotebookCellRunHistoryResponse"> & {
  /**
   * @generated from field: repeated chalk.notebook.v1.NotebookCellRunHistoryEntry cell_runs = 1;
   */
  cellRuns: NotebookCellRunHistoryEntry[];

  /**
   * @generated from field: optional string next_cursor = 2;
   */
  nextCursor?: string;
};

/**
 * Describes the message chalk.notebook.v1.ListNotebookCellRunHistoryResponse.
 * Use `create(ListNotebookCellRunHistoryResponseSchema)` to create a new message.
 */
export const ListNotebookCellRunHistoryResponseSchema: GenMessage<ListNotebookCellRunHistoryResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 37);

/**
 * @generated from message chalk.notebook.v1.ListNotebookRunsRequest
 */
export type ListNotebookRunsRequest = Message<"chalk.notebook.v1.ListNotebookRunsRequest"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;

  /**
   * @generated from field: optional int32 limit = 2;
   */
  limit?: number;

  /**
   * @generated from field: optional string cursor = 3;
   */
  cursor?: string;
};

/**
 * Describes the message chalk.notebook.v1.ListNotebookRunsRequest.
 * Use `create(ListNotebookRunsRequestSchema)` to create a new message.
 */
export const ListNotebookRunsRequestSchema: GenMessage<ListNotebookRunsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 38);

/**
 * @generated from message chalk.notebook.v1.ListNotebookRunsResponse
 */
export type ListNotebookRunsResponse = Message<"chalk.notebook.v1.ListNotebookRunsResponse"> & {
  /**
   * @generated from field: repeated chalk.notebook.v1.NotebookRunSummary runs = 1;
   */
  runs: NotebookRunSummary[];

  /**
   * @generated from field: optional string next_cursor = 2;
   */
  nextCursor?: string;
};

/**
 * Describes the message chalk.notebook.v1.ListNotebookRunsResponse.
 * Use `create(ListNotebookRunsResponseSchema)` to create a new message.
 */
export const ListNotebookRunsResponseSchema: GenMessage<ListNotebookRunsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 39);

/**
 * @generated from message chalk.notebook.v1.GetNotebookRunDetailsRequest
 */
export type GetNotebookRunDetailsRequest = Message<"chalk.notebook.v1.GetNotebookRunDetailsRequest"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;

  /**
   * @generated from field: string run_id = 2;
   */
  runId: string;
};

/**
 * Describes the message chalk.notebook.v1.GetNotebookRunDetailsRequest.
 * Use `create(GetNotebookRunDetailsRequestSchema)` to create a new message.
 */
export const GetNotebookRunDetailsRequestSchema: GenMessage<GetNotebookRunDetailsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 40);

/**
 * @generated from message chalk.notebook.v1.GetNotebookRunDetailsResponse
 */
export type GetNotebookRunDetailsResponse = Message<"chalk.notebook.v1.GetNotebookRunDetailsResponse"> & {
  /**
   * @generated from field: chalk.notebook.v1.NotebookRunSummary run = 1;
   */
  run?: NotebookRunSummary;

  /**
   * Per-cell outcomes of the run, in execution order.
   *
   * @generated from field: repeated chalk.notebook.v1.NotebookCellRunHistoryEntry cell_runs = 2;
   */
  cellRuns: NotebookCellRunHistoryEntry[];
};

/**
 * Describes the message chalk.notebook.v1.GetNotebookRunDetailsResponse.
 * Use `create(GetNotebookRunDetailsResponseSchema)` to create a new message.
 */
export const GetNotebookRunDetailsResponseSchema: GenMessage<GetNotebookRunDetailsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 41);

/**
 * @generated from message chalk.notebook.v1.ListNotebookDocumentRevisionsRequest
 */
export type ListNotebookDocumentRevisionsRequest = Message<"chalk.notebook.v1.ListNotebookDocumentRevisionsRequest"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;

  /**
   * @generated from field: optional int32 limit = 2;
   */
  limit?: number;

  /**
   * @generated from field: optional string cursor = 3;
   */
  cursor?: string;
};

/**
 * Describes the message chalk.notebook.v1.ListNotebookDocumentRevisionsRequest.
 * Use `create(ListNotebookDocumentRevisionsRequestSchema)` to create a new message.
 */
export const ListNotebookDocumentRevisionsRequestSchema: GenMessage<ListNotebookDocumentRevisionsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 42);

/**
 * @generated from message chalk.notebook.v1.ListNotebookDocumentRevisionsResponse
 */
export type ListNotebookDocumentRevisionsResponse = Message<"chalk.notebook.v1.ListNotebookDocumentRevisionsResponse"> & {
  /**
   * @generated from field: repeated chalk.notebook.v1.NotebookDocumentRevision revisions = 1;
   */
  revisions: NotebookDocumentRevision[];

  /**
   * @generated from field: optional string next_cursor = 2;
   */
  nextCursor?: string;
};

/**
 * Describes the message chalk.notebook.v1.ListNotebookDocumentRevisionsResponse.
 * Use `create(ListNotebookDocumentRevisionsResponseSchema)` to create a new message.
 */
export const ListNotebookDocumentRevisionsResponseSchema: GenMessage<ListNotebookDocumentRevisionsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 43);

/**
 * @generated from message chalk.notebook.v1.FetchNotebookDataframeRowsRequest
 */
export type FetchNotebookDataframeRowsRequest = Message<"chalk.notebook.v1.FetchNotebookDataframeRowsRequest"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;

  /**
   * Output chunk whose dataframe backing to page through.
   *
   * @generated from field: string chunk_id = 2;
   */
  chunkId: string;

  /**
   * @generated from field: int64 offset = 3;
   */
  offset: bigint;

  /**
   * Server clamps to its configured maximum page size.
   *
   * @generated from field: int32 limit = 4;
   */
  limit: number;
};

/**
 * Describes the message chalk.notebook.v1.FetchNotebookDataframeRowsRequest.
 * Use `create(FetchNotebookDataframeRowsRequestSchema)` to create a new message.
 */
export const FetchNotebookDataframeRowsRequestSchema: GenMessage<FetchNotebookDataframeRowsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 44);

/**
 * @generated from message chalk.notebook.v1.FetchNotebookDataframeRowsResponse
 */
export type FetchNotebookDataframeRowsResponse = Message<"chalk.notebook.v1.FetchNotebookDataframeRowsResponse"> & {
  /**
   * The requested row range, encoded per the payload oneof. Arrow IPC is the
   * primary encoding, matching the blob artifact format and the
   * chalk.common.v1 convention of shipping tabular data as Arrow/parquet
   * bytes rather than repeated Structs.
   *
   * @generated from oneof chalk.notebook.v1.FetchNotebookDataframeRowsResponse.payload
   */
  payload: {
    /**
     * @generated from field: bytes arrow_ipc = 1;
     */
    value: Uint8Array;
    case: "arrowIpc";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: int64 total_rows = 2;
   */
  totalRows: bigint;

  /**
   * False when the backing store cannot serve rows beyond the persisted
   * preview; clients should stop paging and rely on the preview they have.
   *
   * @generated from field: bool supports_pagination = 3;
   */
  supportsPagination: boolean;
};

/**
 * Describes the message chalk.notebook.v1.FetchNotebookDataframeRowsResponse.
 * Use `create(FetchNotebookDataframeRowsResponseSchema)` to create a new message.
 */
export const FetchNotebookDataframeRowsResponseSchema: GenMessage<FetchNotebookDataframeRowsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 45);

/**
 * @generated from message chalk.notebook.v1.AggregateNotebookDataframeRequest
 */
export type AggregateNotebookDataframeRequest = Message<"chalk.notebook.v1.AggregateNotebookDataframeRequest"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;

  /**
   * Output chunk whose dataframe backing to aggregate.
   *
   * @generated from field: string chunk_id = 2;
   */
  chunkId: string;

  /**
   * @generated from field: string column = 3;
   */
  column: string;

  /**
   * @generated from field: chalk.notebook.v1.NotebookDataframeAggregation aggregation = 4;
   */
  aggregation: NotebookDataframeAggregation;

  /**
   * AGGREGATION_PERCENTILE only: the rank in 0-100 (95 for p95). Ignored by
   * every other aggregation.
   *
   * @generated from field: double percentile = 5;
   */
  percentile: number;
};

/**
 * Describes the message chalk.notebook.v1.AggregateNotebookDataframeRequest.
 * Use `create(AggregateNotebookDataframeRequestSchema)` to create a new message.
 */
export const AggregateNotebookDataframeRequestSchema: GenMessage<AggregateNotebookDataframeRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 46);

/**
 * One percentile of an aggregated column. Percentiles arrive as a set because a
 * client showing p95 also offers the neighbouring ranks on hover, and the server
 * has the sorted column in hand anyway — a request per rank would re-read the
 * whole artifact each time.
 *
 * @generated from message chalk.notebook.v1.NotebookDataframePercentile
 */
export type NotebookDataframePercentile = Message<"chalk.notebook.v1.NotebookDataframePercentile"> & {
  /**
   * The rank in 0-100 (95 for p95).
   *
   * @generated from field: double percentile = 1;
   */
  percentile: number;

  /**
   * @generated from field: double value = 2;
   */
  value: number;
};

/**
 * Describes the message chalk.notebook.v1.NotebookDataframePercentile.
 * Use `create(NotebookDataframePercentileSchema)` to create a new message.
 */
export const NotebookDataframePercentileSchema: GenMessage<NotebookDataframePercentile> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 47);

/**
 * @generated from message chalk.notebook.v1.AggregateNotebookDataframeResponse
 */
export type AggregateNotebookDataframeResponse = Message<"chalk.notebook.v1.AggregateNotebookDataframeResponse"> & {
  /**
   * The aggregate over the full artifact. COUNT / COUNT_DISTINCT are exact
   * counts; the other aggregations reduce the column's numeric values
   * (non-numeric cells are skipped, matching the client-side preview
   * semantics). Unset when the column holds no aggregable values.
   *
   * @generated from field: optional double number_value = 1;
   */
  numberValue?: number;

  /**
   * @generated from field: int64 total_rows = 2;
   */
  totalRows: bigint;

  /**
   * False when the backing store cannot serve the full artifact; clients
   * should fall back to aggregating the preview they already have.
   *
   * @generated from field: bool supports_aggregation = 3;
   */
  supportsAggregation: boolean;

  /**
   * Populated only for AGGREGATION_PERCENTILE: the requested rank plus the
   * other ranks the server computes in the same pass, ascending by rank.
   *
   * @generated from field: repeated chalk.notebook.v1.NotebookDataframePercentile percentiles = 4;
   */
  percentiles: NotebookDataframePercentile[];
};

/**
 * Describes the message chalk.notebook.v1.AggregateNotebookDataframeResponse.
 * Use `create(AggregateNotebookDataframeResponseSchema)` to create a new message.
 */
export const AggregateNotebookDataframeResponseSchema: GenMessage<AggregateNotebookDataframeResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 48);

/**
 * @generated from message chalk.notebook.v1.DownloadNotebookDataframeRequest
 */
export type DownloadNotebookDataframeRequest = Message<"chalk.notebook.v1.DownloadNotebookDataframeRequest"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;

  /**
   * Output chunk whose full dataframe backing to download.
   *
   * @generated from field: string chunk_id = 2;
   */
  chunkId: string;

  /**
   * @generated from field: chalk.notebook.v1.NotebookDataframeDownloadFormat format = 3;
   */
  format: NotebookDataframeDownloadFormat;
};

/**
 * Describes the message chalk.notebook.v1.DownloadNotebookDataframeRequest.
 * Use `create(DownloadNotebookDataframeRequestSchema)` to create a new message.
 */
export const DownloadNotebookDataframeRequestSchema: GenMessage<DownloadNotebookDataframeRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 49);

/**
 * @generated from message chalk.notebook.v1.DownloadNotebookDataframeResponse
 */
export type DownloadNotebookDataframeResponse = Message<"chalk.notebook.v1.DownloadNotebookDataframeResponse"> & {
  /**
   * One frame of the download stream; concatenate frames in order.
   *
   * @generated from field: bytes data = 1;
   */
  data: Uint8Array;

  /**
   * Set on the first frame only.
   *
   * @generated from field: string file_name = 2;
   */
  fileName: string;

  /**
   * @generated from field: string content_type = 3;
   */
  contentType: string;
};

/**
 * Describes the message chalk.notebook.v1.DownloadNotebookDataframeResponse.
 * Use `create(DownloadNotebookDataframeResponseSchema)` to create a new message.
 */
export const DownloadNotebookDataframeResponseSchema: GenMessage<DownloadNotebookDataframeResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 50);

/**
 * @generated from message chalk.notebook.v1.ClearNotebookCellResultsRequest
 */
export type ClearNotebookCellResultsRequest = Message<"chalk.notebook.v1.ClearNotebookCellResultsRequest"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;

  /**
   * @generated from field: repeated string cell_ids = 2;
   */
  cellIds: string[];
};

/**
 * Describes the message chalk.notebook.v1.ClearNotebookCellResultsRequest.
 * Use `create(ClearNotebookCellResultsRequestSchema)` to create a new message.
 */
export const ClearNotebookCellResultsRequestSchema: GenMessage<ClearNotebookCellResultsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 51);

/**
 * @generated from message chalk.notebook.v1.ClearNotebookCellResultsResponse
 */
export type ClearNotebookCellResultsResponse = Message<"chalk.notebook.v1.ClearNotebookCellResultsResponse"> & {
};

/**
 * Describes the message chalk.notebook.v1.ClearNotebookCellResultsResponse.
 * Use `create(ClearNotebookCellResultsResponseSchema)` to create a new message.
 */
export const ClearNotebookCellResultsResponseSchema: GenMessage<ClearNotebookCellResultsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 52);

/**
 * Environment is resolved from request headers, as elsewhere in this service.
 * These RPCs manage only the environment-scope row; notebook- and cell-level
 * staleness settings live in the document/cell protos and are edited through
 * the normal document/cell update paths.
 *
 * @generated from message chalk.notebook.v1.GetNotebookSqlCacheSettingsRequest
 */
export type GetNotebookSqlCacheSettingsRequest = Message<"chalk.notebook.v1.GetNotebookSqlCacheSettingsRequest"> & {
};

/**
 * Describes the message chalk.notebook.v1.GetNotebookSqlCacheSettingsRequest.
 * Use `create(GetNotebookSqlCacheSettingsRequestSchema)` to create a new message.
 */
export const GetNotebookSqlCacheSettingsRequestSchema: GenMessage<GetNotebookSqlCacheSettingsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 53);

/**
 * @generated from message chalk.notebook.v1.GetNotebookSqlCacheSettingsResponse
 */
export type GetNotebookSqlCacheSettingsResponse = Message<"chalk.notebook.v1.GetNotebookSqlCacheSettingsResponse"> & {
  /**
   * The value configured for this environment; absent = no row (inherits).
   *
   * @generated from field: optional google.protobuf.Duration max_staleness = 1;
   */
  maxStaleness?: Duration;

  /**
   * The value that applies after walking env -> team -> server default.
   *
   * @generated from field: google.protobuf.Duration effective_max_staleness = 2;
   */
  effectiveMaxStaleness?: Duration;
};

/**
 * Describes the message chalk.notebook.v1.GetNotebookSqlCacheSettingsResponse.
 * Use `create(GetNotebookSqlCacheSettingsResponseSchema)` to create a new message.
 */
export const GetNotebookSqlCacheSettingsResponseSchema: GenMessage<GetNotebookSqlCacheSettingsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 54);

/**
 * @generated from message chalk.notebook.v1.UpdateNotebookSqlCacheSettingsRequest
 */
export type UpdateNotebookSqlCacheSettingsRequest = Message<"chalk.notebook.v1.UpdateNotebookSqlCacheSettingsRequest"> & {
  /**
   * Absent clears the environment row (revert to team/server default);
   * 0 disables SQL result caching for the environment (absolute: notebook and
   * cell settings cannot re-enable it).
   *
   * @generated from field: optional google.protobuf.Duration max_staleness = 1;
   */
  maxStaleness?: Duration;
};

/**
 * Describes the message chalk.notebook.v1.UpdateNotebookSqlCacheSettingsRequest.
 * Use `create(UpdateNotebookSqlCacheSettingsRequestSchema)` to create a new message.
 */
export const UpdateNotebookSqlCacheSettingsRequestSchema: GenMessage<UpdateNotebookSqlCacheSettingsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 55);

/**
 * @generated from message chalk.notebook.v1.UpdateNotebookSqlCacheSettingsResponse
 */
export type UpdateNotebookSqlCacheSettingsResponse = Message<"chalk.notebook.v1.UpdateNotebookSqlCacheSettingsResponse"> & {
};

/**
 * Describes the message chalk.notebook.v1.UpdateNotebookSqlCacheSettingsResponse.
 * Use `create(UpdateNotebookSqlCacheSettingsResponseSchema)` to create a new message.
 */
export const UpdateNotebookSqlCacheSettingsResponseSchema: GenMessage<UpdateNotebookSqlCacheSettingsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 56);

/**
 * @generated from message chalk.notebook.v1.NotebookRuntimeStatus
 */
export type NotebookRuntimeStatus = Message<"chalk.notebook.v1.NotebookRuntimeStatus"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;

  /**
   * @generated from field: chalk.notebook.v1.NotebookRuntimeState state = 2;
   */
  state: NotebookRuntimeState;

  /**
   * True once the backing container exposes a routable web URL. The URL itself
   * is intentionally not returned to clients; runs resolve it server-side.
   *
   * @generated from field: bool web_url_present = 3;
   */
  webUrlPresent: boolean;

  /**
   * Kernel session id bound to this runtime. Equal to the notebook id for
   * container-backed runtimes; empty for the local-override dev runtime, which
   * owns its own boot-generated session.
   *
   * @generated from field: string session_id = 4;
   */
  sessionId: string;

  /**
   * Human-readable status detail (e.g. container status message). Never a
   * substitute for an error: failures are returned as connect errors.
   *
   * @generated from field: string message = 5;
   */
  message: string;

  /**
   * Last memory usage observed by go-api-server's kernel heartbeat. Zero until
   * a heartbeat has reported cgroup memory accounting for this runtime.
   *
   * @generated from field: uint64 memory_usage_bytes = 6;
   */
  memoryUsageBytes: bigint;

  /**
   * Last cgroup memory ceiling observed by the heartbeat. Zero when the kernel
   * is unlimited, unavailable, or has not yet been probed.
   *
   * @generated from field: uint64 memory_limit_bytes = 7;
   */
  memoryLimitBytes: bigint;
};

/**
 * Describes the message chalk.notebook.v1.NotebookRuntimeStatus.
 * Use `create(NotebookRuntimeStatusSchema)` to create a new message.
 */
export const NotebookRuntimeStatusSchema: GenMessage<NotebookRuntimeStatus> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 57);

/**
 * @generated from message chalk.notebook.v1.StartNotebookRuntimeRequest
 */
export type StartNotebookRuntimeRequest = Message<"chalk.notebook.v1.StartNotebookRuntimeRequest"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;
};

/**
 * Describes the message chalk.notebook.v1.StartNotebookRuntimeRequest.
 * Use `create(StartNotebookRuntimeRequestSchema)` to create a new message.
 */
export const StartNotebookRuntimeRequestSchema: GenMessage<StartNotebookRuntimeRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 58);

/**
 * @generated from message chalk.notebook.v1.StartNotebookRuntimeResponse
 */
export type StartNotebookRuntimeResponse = Message<"chalk.notebook.v1.StartNotebookRuntimeResponse"> & {
  /**
   * @generated from field: chalk.notebook.v1.NotebookRuntimeStatus status = 1;
   */
  status?: NotebookRuntimeStatus;
};

/**
 * Describes the message chalk.notebook.v1.StartNotebookRuntimeResponse.
 * Use `create(StartNotebookRuntimeResponseSchema)` to create a new message.
 */
export const StartNotebookRuntimeResponseSchema: GenMessage<StartNotebookRuntimeResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 59);

/**
 * @generated from message chalk.notebook.v1.StopNotebookRuntimeRequest
 */
export type StopNotebookRuntimeRequest = Message<"chalk.notebook.v1.StopNotebookRuntimeRequest"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;
};

/**
 * Describes the message chalk.notebook.v1.StopNotebookRuntimeRequest.
 * Use `create(StopNotebookRuntimeRequestSchema)` to create a new message.
 */
export const StopNotebookRuntimeRequestSchema: GenMessage<StopNotebookRuntimeRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 60);

/**
 * @generated from message chalk.notebook.v1.StopNotebookRuntimeResponse
 */
export type StopNotebookRuntimeResponse = Message<"chalk.notebook.v1.StopNotebookRuntimeResponse"> & {
  /**
   * @generated from field: chalk.notebook.v1.NotebookRuntimeStatus status = 1;
   */
  status?: NotebookRuntimeStatus;
};

/**
 * Describes the message chalk.notebook.v1.StopNotebookRuntimeResponse.
 * Use `create(StopNotebookRuntimeResponseSchema)` to create a new message.
 */
export const StopNotebookRuntimeResponseSchema: GenMessage<StopNotebookRuntimeResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 61);

/**
 * @generated from message chalk.notebook.v1.GetNotebookRuntimeStatusRequest
 */
export type GetNotebookRuntimeStatusRequest = Message<"chalk.notebook.v1.GetNotebookRuntimeStatusRequest"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;
};

/**
 * Describes the message chalk.notebook.v1.GetNotebookRuntimeStatusRequest.
 * Use `create(GetNotebookRuntimeStatusRequestSchema)` to create a new message.
 */
export const GetNotebookRuntimeStatusRequestSchema: GenMessage<GetNotebookRuntimeStatusRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 62);

/**
 * @generated from message chalk.notebook.v1.GetNotebookRuntimeStatusResponse
 */
export type GetNotebookRuntimeStatusResponse = Message<"chalk.notebook.v1.GetNotebookRuntimeStatusResponse"> & {
  /**
   * @generated from field: chalk.notebook.v1.NotebookRuntimeStatus status = 1;
   */
  status?: NotebookRuntimeStatus;
};

/**
 * Describes the message chalk.notebook.v1.GetNotebookRuntimeStatusResponse.
 * Use `create(GetNotebookRuntimeStatusResponseSchema)` to create a new message.
 */
export const GetNotebookRuntimeStatusResponseSchema: GenMessage<GetNotebookRuntimeStatusResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 63);

/**
 * @generated from message chalk.notebook.v1.WatchNotebookRuntimeStatusRequest
 */
export type WatchNotebookRuntimeStatusRequest = Message<"chalk.notebook.v1.WatchNotebookRuntimeStatusRequest"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;
};

/**
 * Describes the message chalk.notebook.v1.WatchNotebookRuntimeStatusRequest.
 * Use `create(WatchNotebookRuntimeStatusRequestSchema)` to create a new message.
 */
export const WatchNotebookRuntimeStatusRequestSchema: GenMessage<WatchNotebookRuntimeStatusRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 64);

/**
 * @generated from message chalk.notebook.v1.WatchNotebookRuntimeStatusResponse
 */
export type WatchNotebookRuntimeStatusResponse = Message<"chalk.notebook.v1.WatchNotebookRuntimeStatusResponse"> & {
  /**
   * @generated from field: chalk.notebook.v1.NotebookRuntimeStatus status = 1;
   */
  status?: NotebookRuntimeStatus;

  /**
   * Server clock at which this transition was observed and emitted. The stream
   * is edge-triggered (a message is sent only when the status changes), not a
   * heartbeat, so this is the time of the last emitted update — NOT a liveness
   * signal. A stalled or dropped stream stops emitting entirely; do not treat a
   * stale observed_at as "the server last checked at this time".
   *
   * @generated from field: google.protobuf.Timestamp observed_at = 2;
   */
  observedAt?: Timestamp;
};

/**
 * Describes the message chalk.notebook.v1.WatchNotebookRuntimeStatusResponse.
 * Use `create(WatchNotebookRuntimeStatusResponseSchema)` to create a new message.
 */
export const WatchNotebookRuntimeStatusResponseSchema: GenMessage<WatchNotebookRuntimeStatusResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 65);

/**
 * A single live kernel runtime for the environment-scoped kernels list.
 *
 * @generated from message chalk.notebook.v1.NotebookRuntimeSummary
 */
export type NotebookRuntimeSummary = Message<"chalk.notebook.v1.NotebookRuntimeSummary"> & {
  /**
   * Resolved runtime state (notebook_id, state, web_url_present, ...), computed
   * the same way GetNotebookRuntimeStatus computes it for one notebook.
   *
   * @generated from field: chalk.notebook.v1.NotebookRuntimeStatus status = 1;
   */
  status?: NotebookRuntimeStatus;

  /**
   * Human title of the backing notebook document; falls back to the runtime
   * row name when the document row is unavailable.
   *
   * @generated from field: string notebook_title = 2;
   */
  notebookTitle: string;

  /**
   * Id of the backing chalk_nb_server container.
   *
   * @generated from field: string container_id = 3;
   */
  containerId: string;

  /**
   * When the backing container was created.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message chalk.notebook.v1.NotebookRuntimeSummary.
 * Use `create(NotebookRuntimeSummarySchema)` to create a new message.
 */
export const NotebookRuntimeSummarySchema: GenMessage<NotebookRuntimeSummary> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 66);

/**
 * @generated from message chalk.notebook.v1.ListNotebookRuntimesRequest
 */
export type ListNotebookRuntimesRequest = Message<"chalk.notebook.v1.ListNotebookRuntimesRequest"> & {
};

/**
 * Describes the message chalk.notebook.v1.ListNotebookRuntimesRequest.
 * Use `create(ListNotebookRuntimesRequestSchema)` to create a new message.
 */
export const ListNotebookRuntimesRequestSchema: GenMessage<ListNotebookRuntimesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 67);

/**
 * @generated from message chalk.notebook.v1.ListNotebookRuntimesResponse
 */
export type ListNotebookRuntimesResponse = Message<"chalk.notebook.v1.ListNotebookRuntimesResponse"> & {
  /**
   * Live kernel runtimes (non-stopped notebooks with a non-stopped backing
   * container) in the request's environment, newest first.
   *
   * @generated from field: repeated chalk.notebook.v1.NotebookRuntimeSummary runtimes = 1;
   */
  runtimes: NotebookRuntimeSummary[];
};

/**
 * Describes the message chalk.notebook.v1.ListNotebookRuntimesResponse.
 * Use `create(ListNotebookRuntimesResponseSchema)` to create a new message.
 */
export const ListNotebookRuntimesResponseSchema: GenMessage<ListNotebookRuntimesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 68);

/**
 * @generated from message chalk.notebook.v1.ListNotebookKernelPackagesRequest
 */
export type ListNotebookKernelPackagesRequest = Message<"chalk.notebook.v1.ListNotebookKernelPackagesRequest"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;
};

/**
 * Describes the message chalk.notebook.v1.ListNotebookKernelPackagesRequest.
 * Use `create(ListNotebookKernelPackagesRequestSchema)` to create a new message.
 */
export const ListNotebookKernelPackagesRequestSchema: GenMessage<ListNotebookKernelPackagesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 69);

/**
 * @generated from message chalk.notebook.v1.ListNotebookKernelPackagesResponse
 */
export type ListNotebookKernelPackagesResponse = Message<"chalk.notebook.v1.ListNotebookKernelPackagesResponse"> & {
  /**
   * Packages installed in the notebook's running kernel, sorted by name.
   *
   * @generated from field: repeated chalk.notebook.v1.InstalledPackage packages = 1;
   */
  packages: InstalledPackage[];

  /**
   * Build identity of the kernel, passed through from its own response. Lets the
   * settings drawer answer "which build am I on" beside the package list rather
   * than requiring a cell that imports libchalk and prints __version__.
   *
   * @generated from field: chalk.notebook.v1.KernelBuildInfo build = 2;
   */
  build?: KernelBuildInfo;
};

/**
 * Describes the message chalk.notebook.v1.ListNotebookKernelPackagesResponse.
 * Use `create(ListNotebookKernelPackagesResponseSchema)` to create a new message.
 */
export const ListNotebookKernelPackagesResponseSchema: GenMessage<ListNotebookKernelPackagesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 70);

/**
 * @generated from message chalk.notebook.v1.GetNotebookDependencyGraphRequest
 */
export type GetNotebookDependencyGraphRequest = Message<"chalk.notebook.v1.GetNotebookDependencyGraphRequest"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;
};

/**
 * Describes the message chalk.notebook.v1.GetNotebookDependencyGraphRequest.
 * Use `create(GetNotebookDependencyGraphRequestSchema)` to create a new message.
 */
export const GetNotebookDependencyGraphRequestSchema: GenMessage<GetNotebookDependencyGraphRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 71);

/**
 * A node in the notebook dependency DAG: one runnable cell.
 *
 * @generated from message chalk.notebook.v1.DependencyNode
 */
export type DependencyNode = Message<"chalk.notebook.v1.DependencyNode"> & {
  /**
   * @generated from field: string cell_id = 1;
   */
  cellId: string;

  /**
   * Human-readable label for the node (cell display name, result variable
   * name, or a positional fallback like "Cell 3").
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * Cell body kind ("python", "sql", "online_query", "offline_query", ...) —
   * matches the string cell-kind used elsewhere in the notebook module.
   *
   * @generated from field: string cell_kind = 3;
   */
  cellKind: string;
};

/**
 * Describes the message chalk.notebook.v1.DependencyNode.
 * Use `create(DependencyNodeSchema)` to create a new message.
 */
export const DependencyNodeSchema: GenMessage<DependencyNode> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 72);

/**
 * A directed edge in the DAG: data flows from a producing cell to a consuming
 * cell. `variable_names` are the names the consumer requires that the producer
 * provides, so an edge can be labeled with what actually flows across it.
 *
 * @generated from message chalk.notebook.v1.DependencyEdge
 */
export type DependencyEdge = Message<"chalk.notebook.v1.DependencyEdge"> & {
  /**
   * @generated from field: string from_cell_id = 1;
   */
  fromCellId: string;

  /**
   * @generated from field: string to_cell_id = 2;
   */
  toCellId: string;

  /**
   * @generated from field: repeated string variable_names = 3;
   */
  variableNames: string[];
};

/**
 * Describes the message chalk.notebook.v1.DependencyEdge.
 * Use `create(DependencyEdgeSchema)` to create a new message.
 */
export const DependencyEdgeSchema: GenMessage<DependencyEdge> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 73);

/**
 * The assembled dependency graph for a notebook. Unlike the kernel's per-cell
 * CellDependencyReport (raw provides/requires), this is the cross-cell graph:
 * go assembles edges with last-producer-wins — for each cell's required name,
 * the edge source is the most recent PRIOR cell in document order that
 * provides that name.
 *
 * @generated from message chalk.notebook.v1.GetNotebookDependencyGraphResponse
 */
export type GetNotebookDependencyGraphResponse = Message<"chalk.notebook.v1.GetNotebookDependencyGraphResponse"> & {
  /**
   * @generated from field: repeated chalk.notebook.v1.DependencyNode nodes = 1;
   */
  nodes: DependencyNode[];

  /**
   * @generated from field: repeated chalk.notebook.v1.DependencyEdge edges = 2;
   */
  edges: DependencyEdge[];
};

/**
 * Describes the message chalk.notebook.v1.GetNotebookDependencyGraphResponse.
 * Use `create(GetNotebookDependencyGraphResponseSchema)` to create a new message.
 */
export const GetNotebookDependencyGraphResponseSchema: GenMessage<GetNotebookDependencyGraphResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 74);

/**
 * @generated from message chalk.notebook.v1.ListNotebookSecretsRequest
 */
export type ListNotebookSecretsRequest = Message<"chalk.notebook.v1.ListNotebookSecretsRequest"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;
};

/**
 * Describes the message chalk.notebook.v1.ListNotebookSecretsRequest.
 * Use `create(ListNotebookSecretsRequestSchema)` to create a new message.
 */
export const ListNotebookSecretsRequestSchema: GenMessage<ListNotebookSecretsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 75);

/**
 * @generated from message chalk.notebook.v1.ListNotebookSecretsResponse
 */
export type ListNotebookSecretsResponse = Message<"chalk.notebook.v1.ListNotebookSecretsResponse"> & {
  /**
   * @generated from field: repeated chalk.notebook.v1.NotebookSecret secrets = 1;
   */
  secrets: NotebookSecret[];
};

/**
 * Describes the message chalk.notebook.v1.ListNotebookSecretsResponse.
 * Use `create(ListNotebookSecretsResponseSchema)` to create a new message.
 */
export const ListNotebookSecretsResponseSchema: GenMessage<ListNotebookSecretsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 76);

/**
 * @generated from message chalk.notebook.v1.GetNotebookSecretValueRequest
 */
export type GetNotebookSecretValueRequest = Message<"chalk.notebook.v1.GetNotebookSecretValueRequest"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;

  /**
   * @generated from field: string secret_id = 2;
   */
  secretId: string;
};

/**
 * Describes the message chalk.notebook.v1.GetNotebookSecretValueRequest.
 * Use `create(GetNotebookSecretValueRequestSchema)` to create a new message.
 */
export const GetNotebookSecretValueRequestSchema: GenMessage<GetNotebookSecretValueRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 77);

/**
 * @generated from message chalk.notebook.v1.GetNotebookSecretValueResponse
 */
export type GetNotebookSecretValueResponse = Message<"chalk.notebook.v1.GetNotebookSecretValueResponse"> & {
  /**
   * @generated from field: optional chalk.notebook.v1.NotebookSecretValue secret_value = 1;
   */
  secretValue?: NotebookSecretValue;
};

/**
 * Describes the message chalk.notebook.v1.GetNotebookSecretValueResponse.
 * Use `create(GetNotebookSecretValueResponseSchema)` to create a new message.
 */
export const GetNotebookSecretValueResponseSchema: GenMessage<GetNotebookSecretValueResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 78);

/**
 * @generated from message chalk.notebook.v1.UpsertNotebookSecretRequest
 */
export type UpsertNotebookSecretRequest = Message<"chalk.notebook.v1.UpsertNotebookSecretRequest"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;

  /**
   * @generated from field: optional string secret_id = 2;
   */
  secretId?: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: chalk.server.v1.SecretConfigValue config = 4;
   */
  config?: SecretConfigValue;
};

/**
 * Describes the message chalk.notebook.v1.UpsertNotebookSecretRequest.
 * Use `create(UpsertNotebookSecretRequestSchema)` to create a new message.
 */
export const UpsertNotebookSecretRequestSchema: GenMessage<UpsertNotebookSecretRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 79);

/**
 * @generated from message chalk.notebook.v1.UpsertNotebookSecretResponse
 */
export type UpsertNotebookSecretResponse = Message<"chalk.notebook.v1.UpsertNotebookSecretResponse"> & {
  /**
   * @generated from field: repeated chalk.notebook.v1.NotebookSecret secrets = 1;
   */
  secrets: NotebookSecret[];
};

/**
 * Describes the message chalk.notebook.v1.UpsertNotebookSecretResponse.
 * Use `create(UpsertNotebookSecretResponseSchema)` to create a new message.
 */
export const UpsertNotebookSecretResponseSchema: GenMessage<UpsertNotebookSecretResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 80);

/**
 * @generated from message chalk.notebook.v1.DeleteNotebookSecretRequest
 */
export type DeleteNotebookSecretRequest = Message<"chalk.notebook.v1.DeleteNotebookSecretRequest"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;

  /**
   * @generated from field: string secret_id = 2;
   */
  secretId: string;
};

/**
 * Describes the message chalk.notebook.v1.DeleteNotebookSecretRequest.
 * Use `create(DeleteNotebookSecretRequestSchema)` to create a new message.
 */
export const DeleteNotebookSecretRequestSchema: GenMessage<DeleteNotebookSecretRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 81);

/**
 * @generated from message chalk.notebook.v1.DeleteNotebookSecretResponse
 */
export type DeleteNotebookSecretResponse = Message<"chalk.notebook.v1.DeleteNotebookSecretResponse"> & {
  /**
   * @generated from field: repeated chalk.notebook.v1.NotebookSecret secrets = 1;
   */
  secrets: NotebookSecret[];
};

/**
 * Describes the message chalk.notebook.v1.DeleteNotebookSecretResponse.
 * Use `create(DeleteNotebookSecretResponseSchema)` to create a new message.
 */
export const DeleteNotebookSecretResponseSchema: GenMessage<DeleteNotebookSecretResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 82);

/**
 * A comment on a notebook. cell_id anchors the comment to one cell and is a
 * soft ref (comments survive cell deletion); unset means the comment is on
 * the document as a whole. Top-level comments (parent_id unset) each start a
 * thread; replies reference their root via parent_id and inherit its anchor.
 *
 * @generated from message chalk.notebook.v1.NotebookComment
 */
export type NotebookComment = Message<"chalk.notebook.v1.NotebookComment"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string notebook_id = 2;
   */
  notebookId: string;

  /**
   * @generated from field: optional string cell_id = 3;
   */
  cellId?: string;

  /**
   * @generated from field: string body = 4;
   */
  body: string;

  /**
   * @generated from field: string created_by = 5;
   */
  createdBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * Root comment this reply belongs to; unset for top-level comments.
   * Replies are one level deep — a reply's parent is always top-level.
   *
   * @generated from field: optional string parent_id = 7;
   */
  parentId?: string;

  /**
   * Set when the thread this top-level comment starts has been resolved;
   * never set on replies.
   *
   * @generated from field: optional google.protobuf.Timestamp resolved_at = 8;
   */
  resolvedAt?: Timestamp;

  /**
   * Reactions aggregated per emoji; a reaction's count is reacted_by's size.
   *
   * @generated from field: repeated chalk.notebook.v1.NotebookCommentReaction reactions = 9;
   */
  reactions: NotebookCommentReaction[];
};

/**
 * Describes the message chalk.notebook.v1.NotebookComment.
 * Use `create(NotebookCommentSchema)` to create a new message.
 */
export const NotebookCommentSchema: GenMessage<NotebookComment> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 83);

/**
 * All reactors for one emoji on one comment, oldest first.
 *
 * @generated from message chalk.notebook.v1.NotebookCommentReaction
 */
export type NotebookCommentReaction = Message<"chalk.notebook.v1.NotebookCommentReaction"> & {
  /**
   * @generated from field: string emoji = 1;
   */
  emoji: string;

  /**
   * @generated from field: repeated string reacted_by = 2;
   */
  reactedBy: string[];
};

/**
 * Describes the message chalk.notebook.v1.NotebookCommentReaction.
 * Use `create(NotebookCommentReactionSchema)` to create a new message.
 */
export const NotebookCommentReactionSchema: GenMessage<NotebookCommentReaction> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 84);

/**
 * @generated from message chalk.notebook.v1.CreateNotebookCommentRequest
 */
export type CreateNotebookCommentRequest = Message<"chalk.notebook.v1.CreateNotebookCommentRequest"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;

  /**
   * Unset for a document-level comment. Ignored for replies, which inherit
   * the root comment's anchor.
   *
   * @generated from field: optional string cell_id = 2;
   */
  cellId?: string;

  /**
   * @generated from field: string body = 3;
   */
  body: string;

  /**
   * Set to reply to a top-level comment.
   *
   * @generated from field: optional string parent_id = 4;
   */
  parentId?: string;
};

/**
 * Describes the message chalk.notebook.v1.CreateNotebookCommentRequest.
 * Use `create(CreateNotebookCommentRequestSchema)` to create a new message.
 */
export const CreateNotebookCommentRequestSchema: GenMessage<CreateNotebookCommentRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 85);

/**
 * @generated from message chalk.notebook.v1.CreateNotebookCommentResponse
 */
export type CreateNotebookCommentResponse = Message<"chalk.notebook.v1.CreateNotebookCommentResponse"> & {
  /**
   * @generated from field: chalk.notebook.v1.NotebookComment comment = 1;
   */
  comment?: NotebookComment;
};

/**
 * Describes the message chalk.notebook.v1.CreateNotebookCommentResponse.
 * Use `create(CreateNotebookCommentResponseSchema)` to create a new message.
 */
export const CreateNotebookCommentResponseSchema: GenMessage<CreateNotebookCommentResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 86);

/**
 * @generated from message chalk.notebook.v1.ListNotebookCommentsRequest
 */
export type ListNotebookCommentsRequest = Message<"chalk.notebook.v1.ListNotebookCommentsRequest"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;
};

/**
 * Describes the message chalk.notebook.v1.ListNotebookCommentsRequest.
 * Use `create(ListNotebookCommentsRequestSchema)` to create a new message.
 */
export const ListNotebookCommentsRequestSchema: GenMessage<ListNotebookCommentsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 87);

/**
 * @generated from message chalk.notebook.v1.ListNotebookCommentsResponse
 */
export type ListNotebookCommentsResponse = Message<"chalk.notebook.v1.ListNotebookCommentsResponse"> & {
  /**
   * All comments on the document and its cells, oldest first.
   *
   * @generated from field: repeated chalk.notebook.v1.NotebookComment comments = 1;
   */
  comments: NotebookComment[];
};

/**
 * Describes the message chalk.notebook.v1.ListNotebookCommentsResponse.
 * Use `create(ListNotebookCommentsResponseSchema)` to create a new message.
 */
export const ListNotebookCommentsResponseSchema: GenMessage<ListNotebookCommentsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 88);

/**
 * @generated from message chalk.notebook.v1.DeleteNotebookCommentRequest
 */
export type DeleteNotebookCommentRequest = Message<"chalk.notebook.v1.DeleteNotebookCommentRequest"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;

  /**
   * @generated from field: string comment_id = 2;
   */
  commentId: string;
};

/**
 * Describes the message chalk.notebook.v1.DeleteNotebookCommentRequest.
 * Use `create(DeleteNotebookCommentRequestSchema)` to create a new message.
 */
export const DeleteNotebookCommentRequestSchema: GenMessage<DeleteNotebookCommentRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 89);

/**
 * @generated from message chalk.notebook.v1.DeleteNotebookCommentResponse
 */
export type DeleteNotebookCommentResponse = Message<"chalk.notebook.v1.DeleteNotebookCommentResponse"> & {
};

/**
 * Describes the message chalk.notebook.v1.DeleteNotebookCommentResponse.
 * Use `create(DeleteNotebookCommentResponseSchema)` to create a new message.
 */
export const DeleteNotebookCommentResponseSchema: GenMessage<DeleteNotebookCommentResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 90);

/**
 * @generated from message chalk.notebook.v1.SetNotebookCommentResolvedRequest
 */
export type SetNotebookCommentResolvedRequest = Message<"chalk.notebook.v1.SetNotebookCommentResolvedRequest"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;

  /**
   * Must be a top-level comment; resolution applies to its whole thread.
   *
   * @generated from field: string comment_id = 2;
   */
  commentId: string;

  /**
   * @generated from field: bool resolved = 3;
   */
  resolved: boolean;
};

/**
 * Describes the message chalk.notebook.v1.SetNotebookCommentResolvedRequest.
 * Use `create(SetNotebookCommentResolvedRequestSchema)` to create a new message.
 */
export const SetNotebookCommentResolvedRequestSchema: GenMessage<SetNotebookCommentResolvedRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 91);

/**
 * @generated from message chalk.notebook.v1.SetNotebookCommentResolvedResponse
 */
export type SetNotebookCommentResolvedResponse = Message<"chalk.notebook.v1.SetNotebookCommentResolvedResponse"> & {
  /**
   * @generated from field: chalk.notebook.v1.NotebookComment comment = 1;
   */
  comment?: NotebookComment;
};

/**
 * Describes the message chalk.notebook.v1.SetNotebookCommentResolvedResponse.
 * Use `create(SetNotebookCommentResolvedResponseSchema)` to create a new message.
 */
export const SetNotebookCommentResolvedResponseSchema: GenMessage<SetNotebookCommentResolvedResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 92);

/**
 * @generated from message chalk.notebook.v1.ToggleNotebookCommentReactionRequest
 */
export type ToggleNotebookCommentReactionRequest = Message<"chalk.notebook.v1.ToggleNotebookCommentReactionRequest"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;

  /**
   * @generated from field: string comment_id = 2;
   */
  commentId: string;

  /**
   * The reaction emoji exactly as entered (system emoji keyboard).
   *
   * @generated from field: string emoji = 3;
   */
  emoji: string;
};

/**
 * Describes the message chalk.notebook.v1.ToggleNotebookCommentReactionRequest.
 * Use `create(ToggleNotebookCommentReactionRequestSchema)` to create a new message.
 */
export const ToggleNotebookCommentReactionRequestSchema: GenMessage<ToggleNotebookCommentReactionRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 93);

/**
 * @generated from message chalk.notebook.v1.ToggleNotebookCommentReactionResponse
 */
export type ToggleNotebookCommentReactionResponse = Message<"chalk.notebook.v1.ToggleNotebookCommentReactionResponse"> & {
  /**
   * @generated from field: chalk.notebook.v1.NotebookComment comment = 1;
   */
  comment?: NotebookComment;
};

/**
 * Describes the message chalk.notebook.v1.ToggleNotebookCommentReactionResponse.
 * Use `create(ToggleNotebookCommentReactionResponseSchema)` to create a new message.
 */
export const ToggleNotebookCommentReactionResponseSchema: GenMessage<ToggleNotebookCommentReactionResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 94);

/**
 * @generated from message chalk.notebook.v1.CreateNotebookShareLinkRequest
 */
export type CreateNotebookShareLinkRequest = Message<"chalk.notebook.v1.CreateNotebookShareLinkRequest"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;

  /**
   * Human-readable label, so links can be told apart when deciding what to
   * revoke. Optional.
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * When false the link is public: anyone holding the URL may read the
   * notebook, with no Chalk account. When true the holder must additionally be
   * a signed-in member of the owning team.
   *
   * @generated from field: bool require_authentication = 3;
   */
  requireAuthentication: boolean;

  /**
   * Absent creates a link that does not expire.
   *
   * @generated from field: optional google.protobuf.Duration expires_in = 4;
   */
  expiresIn?: Duration;
};

/**
 * Describes the message chalk.notebook.v1.CreateNotebookShareLinkRequest.
 * Use `create(CreateNotebookShareLinkRequestSchema)` to create a new message.
 */
export const CreateNotebookShareLinkRequestSchema: GenMessage<CreateNotebookShareLinkRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 95);

/**
 * @generated from message chalk.notebook.v1.CreateNotebookShareLinkResponse
 */
export type CreateNotebookShareLinkResponse = Message<"chalk.notebook.v1.CreateNotebookShareLinkResponse"> & {
  /**
   * The only response that populates `url`. The server stores a hash of the
   * token, so the URL cannot be recovered after this call returns.
   *
   * @generated from field: chalk.notebook.v1.NotebookShareLink link = 1;
   */
  link?: NotebookShareLink;
};

/**
 * Describes the message chalk.notebook.v1.CreateNotebookShareLinkResponse.
 * Use `create(CreateNotebookShareLinkResponseSchema)` to create a new message.
 */
export const CreateNotebookShareLinkResponseSchema: GenMessage<CreateNotebookShareLinkResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 96);

/**
 * @generated from message chalk.notebook.v1.ListNotebookShareLinksRequest
 */
export type ListNotebookShareLinksRequest = Message<"chalk.notebook.v1.ListNotebookShareLinksRequest"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;

  /**
   * When false (default), revoked and expired links are omitted.
   *
   * @generated from field: bool include_inactive = 2;
   */
  includeInactive: boolean;
};

/**
 * Describes the message chalk.notebook.v1.ListNotebookShareLinksRequest.
 * Use `create(ListNotebookShareLinksRequestSchema)` to create a new message.
 */
export const ListNotebookShareLinksRequestSchema: GenMessage<ListNotebookShareLinksRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 97);

/**
 * @generated from message chalk.notebook.v1.ListNotebookShareLinksResponse
 */
export type ListNotebookShareLinksResponse = Message<"chalk.notebook.v1.ListNotebookShareLinksResponse"> & {
  /**
   * @generated from field: repeated chalk.notebook.v1.NotebookShareLink links = 1;
   */
  links: NotebookShareLink[];
};

/**
 * Describes the message chalk.notebook.v1.ListNotebookShareLinksResponse.
 * Use `create(ListNotebookShareLinksResponseSchema)` to create a new message.
 */
export const ListNotebookShareLinksResponseSchema: GenMessage<ListNotebookShareLinksResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 98);

/**
 * @generated from message chalk.notebook.v1.RevokeNotebookShareLinkRequest
 */
export type RevokeNotebookShareLinkRequest = Message<"chalk.notebook.v1.RevokeNotebookShareLinkRequest"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;

  /**
   * @generated from field: string share_link_id = 2;
   */
  shareLinkId: string;
};

/**
 * Describes the message chalk.notebook.v1.RevokeNotebookShareLinkRequest.
 * Use `create(RevokeNotebookShareLinkRequestSchema)` to create a new message.
 */
export const RevokeNotebookShareLinkRequestSchema: GenMessage<RevokeNotebookShareLinkRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 99);

/**
 * @generated from message chalk.notebook.v1.RevokeNotebookShareLinkResponse
 */
export type RevokeNotebookShareLinkResponse = Message<"chalk.notebook.v1.RevokeNotebookShareLinkResponse"> & {
  /**
   * @generated from field: chalk.notebook.v1.NotebookShareLink link = 1;
   */
  link?: NotebookShareLink;
};

/**
 * Describes the message chalk.notebook.v1.RevokeNotebookShareLinkResponse.
 * Use `create(RevokeNotebookShareLinkResponseSchema)` to create a new message.
 */
export const RevokeNotebookShareLinkResponseSchema: GenMessage<RevokeNotebookShareLinkResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 100);

/**
 * Carries no fields: the share token travels in the request headers, and the
 * notebook it points at is what this call returns.
 *
 * @generated from message chalk.notebook.v1.ResolveNotebookShareLinkRequest
 */
export type ResolveNotebookShareLinkRequest = Message<"chalk.notebook.v1.ResolveNotebookShareLinkRequest"> & {
};

/**
 * Describes the message chalk.notebook.v1.ResolveNotebookShareLinkRequest.
 * Use `create(ResolveNotebookShareLinkRequestSchema)` to create a new message.
 */
export const ResolveNotebookShareLinkRequestSchema: GenMessage<ResolveNotebookShareLinkRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 101);

/**
 * @generated from message chalk.notebook.v1.ResolveNotebookShareLinkResponse
 */
export type ResolveNotebookShareLinkResponse = Message<"chalk.notebook.v1.ResolveNotebookShareLinkResponse"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;

  /**
   * @generated from field: string environment_id = 2;
   */
  environmentId: string;

  /**
   * @generated from field: string notebook_title = 3;
   */
  notebookTitle: string;
};

/**
 * Describes the message chalk.notebook.v1.ResolveNotebookShareLinkResponse.
 * Use `create(ResolveNotebookShareLinkResponseSchema)` to create a new message.
 */
export const ResolveNotebookShareLinkResponseSchema: GenMessage<ResolveNotebookShareLinkResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 102);

/**
 * @generated from message chalk.notebook.v1.ListNotebookDocumentsFilters
 */
export type ListNotebookDocumentsFilters = Message<"chalk.notebook.v1.ListNotebookDocumentsFilters"> & {
  /**
   * When true, only notebooks favorited by the requesting user are returned.
   *
   * @generated from field: optional bool favorites_only = 1;
   */
  favoritesOnly?: boolean;

  /**
   * @generated from field: repeated string statuses = 2;
   */
  statuses: string[];

  /**
   * @generated from field: repeated string categories = 3;
   */
  categories: string[];

  /**
   * When true, archived notebooks (archived_at set) are included.
   *
   * @generated from field: optional bool include_archived = 4;
   */
  includeArchived?: boolean;

  /**
   * Case-insensitive substring match against the notebook title.
   *
   * @generated from field: optional string search = 5;
   */
  search?: string;

  /**
   * @generated from field: repeated string created_by = 6;
   */
  createdBy: string[];

  /**
   * @generated from field: repeated string updated_by = 7;
   */
  updatedBy: string[];
};

/**
 * Describes the message chalk.notebook.v1.ListNotebookDocumentsFilters.
 * Use `create(ListNotebookDocumentsFiltersSchema)` to create a new message.
 */
export const ListNotebookDocumentsFiltersSchema: GenMessage<ListNotebookDocumentsFilters> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_document_service, 103);

/**
 * @generated from enum chalk.notebook.v1.NotebookDocumentSortColumn
 */
export enum NotebookDocumentSortColumn {
  /**
   * @generated from enum value: NOTEBOOK_DOCUMENT_SORT_COLUMN_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: NOTEBOOK_DOCUMENT_SORT_COLUMN_TITLE = 1;
   */
  TITLE = 1,

  /**
   * @generated from enum value: NOTEBOOK_DOCUMENT_SORT_COLUMN_CREATED_AT = 2;
   */
  CREATED_AT = 2,

  /**
   * @generated from enum value: NOTEBOOK_DOCUMENT_SORT_COLUMN_UPDATED_AT = 3;
   */
  UPDATED_AT = 3,
}

/**
 * Describes the enum chalk.notebook.v1.NotebookDocumentSortColumn.
 */
export const NotebookDocumentSortColumnSchema: GenEnum<NotebookDocumentSortColumn> = /*@__PURE__*/
  enumDesc(file_chalk_notebook_v1_document_service, 0);

/**
 * @generated from enum chalk.notebook.v1.NotebookDocumentSortOrder
 */
export enum NotebookDocumentSortOrder {
  /**
   * @generated from enum value: NOTEBOOK_DOCUMENT_SORT_ORDER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: NOTEBOOK_DOCUMENT_SORT_ORDER_ASC = 1;
   */
  ASC = 1,

  /**
   * @generated from enum value: NOTEBOOK_DOCUMENT_SORT_ORDER_DESC = 2;
   */
  DESC = 2,
}

/**
 * Describes the enum chalk.notebook.v1.NotebookDocumentSortOrder.
 */
export const NotebookDocumentSortOrderSchema: GenEnum<NotebookDocumentSortOrder> = /*@__PURE__*/
  enumDesc(file_chalk_notebook_v1_document_service, 1);

/**
 * What changed in a notebook. Events are *hints*: they carry identity only, and
 * the client re-reads the state they name. That keeps one stream able to describe
 * every kind of change without becoming a second, divergent read API.
 *
 * @generated from enum chalk.notebook.v1.NotebookWatchEventType
 */
export enum NotebookWatchEventType {
  /**
   * @generated from enum value: NOTEBOOK_WATCH_EVENT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The document or one of its cells changed. revision_id is the document's new
   * revision; a client that already holds it made this change itself and can
   * ignore the event.
   *
   * @generated from enum value: NOTEBOOK_WATCH_EVENT_TYPE_DOCUMENT_CHANGED = 1;
   */
  DOCUMENT_CHANGED = 1,

  /**
   * Persisted cell results changed outside a run (a clear, for example). Changes
   * during a run arrive as RUN_STATE_CHANGED instead.
   *
   * @generated from enum value: NOTEBOOK_WATCH_EVENT_TYPE_CELL_RESULTS_CHANGED = 2;
   */
  CELL_RESULTS_CHANGED = 2,

  /**
   * A run started or reached a terminal state. run_id is set, so a client that
   * did not start the run can attach to it.
   *
   * @generated from enum value: NOTEBOOK_WATCH_EVENT_TYPE_RUN_STATE_CHANGED = 3;
   */
  RUN_STATE_CHANGED = 3,

  /**
   * Reserved: comments are not published yet, so this is never sent. Declared
   * now so adding it later needs no wire change.
   *
   * @generated from enum value: NOTEBOOK_WATCH_EVENT_TYPE_COMMENTS_CHANGED = 4;
   */
  COMMENTS_CHANGED = 4,

  /**
   * Reserved: kernel runtime status still has its own stream
   * (WatchNotebookRuntimeStatus), whose cadence and consumers differ. Declared
   * now so folding it in later is an implementation change, not a wire change.
   *
   * @generated from enum value: NOTEBOOK_WATCH_EVENT_TYPE_RUNTIME_STATUS_CHANGED = 5;
   */
  RUNTIME_STATUS_CHANGED = 5,
}

/**
 * Describes the enum chalk.notebook.v1.NotebookWatchEventType.
 */
export const NotebookWatchEventTypeSchema: GenEnum<NotebookWatchEventType> = /*@__PURE__*/
  enumDesc(file_chalk_notebook_v1_document_service, 2);

/**
 * How a write should behave when a cell's expected_cell_revision_id no longer
 * matches, i.e. someone else edited the same cell first.
 *
 * @generated from enum chalk.notebook.v1.NotebookCellConflictResolution
 */
export enum NotebookCellConflictResolution {
  /**
   * Same as FAIL: a cell-revision mismatch is a FailedPrecondition. Default so
   * existing callers keep their current all-or-nothing semantics.
   *
   * @generated from enum value: NOTEBOOK_CELL_CONFLICT_RESOLUTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: NOTEBOOK_CELL_CONFLICT_RESOLUTION_FAIL = 1;
   */
  FAIL = 1,

  /**
   * Attempt a line-level three-way merge of the cell's source text, using the
   * revision named by expected_cell_revision_id as the merge base. The merge
   * only applies to text-bearing cells whose body kind and name did not also
   * diverge; anything else, and any overlapping edit, still fails with
   * FailedPrecondition. Merged cells are reported in merged_cell_ids, because
   * what was persisted is then not verbatim what the caller sent.
   *
   * @generated from enum value: NOTEBOOK_CELL_CONFLICT_RESOLUTION_MERGE = 2;
   */
  MERGE = 2,
}

/**
 * Describes the enum chalk.notebook.v1.NotebookCellConflictResolution.
 */
export const NotebookCellConflictResolutionSchema: GenEnum<NotebookCellConflictResolution> = /*@__PURE__*/
  enumDesc(file_chalk_notebook_v1_document_service, 3);

/**
 * @generated from enum chalk.notebook.v1.NotebookInterruptOutcome
 */
export enum NotebookInterruptOutcome {
  /**
   * @generated from enum value: NOTEBOOK_INTERRUPT_OUTCOME_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The interrupt reached the kernel and was acknowledged.
   *
   * @generated from enum value: NOTEBOOK_INTERRUPT_OUTCOME_INTERRUPTED = 1;
   */
  INTERRUPTED = 1,

  /**
   * The run had already reached a terminal state.
   *
   * @generated from enum value: NOTEBOOK_INTERRUPT_OUTCOME_ALREADY_FINISHED = 2;
   */
  ALREADY_FINISHED = 2,

  /**
   * The run was canceled before its cell reached the kernel.
   *
   * @generated from enum value: NOTEBOOK_INTERRUPT_OUTCOME_CANCELED_BEFORE_EXECUTION = 3;
   */
  CANCELED_BEFORE_EXECUTION = 3,

  /**
   * The interrupt was sent but the kernel did not acknowledge in time.
   *
   * @generated from enum value: NOTEBOOK_INTERRUPT_OUTCOME_KERNEL_UNRESPONSIVE = 4;
   */
  KERNEL_UNRESPONSIVE = 4,
}

/**
 * Describes the enum chalk.notebook.v1.NotebookInterruptOutcome.
 */
export const NotebookInterruptOutcomeSchema: GenEnum<NotebookInterruptOutcome> = /*@__PURE__*/
  enumDesc(file_chalk_notebook_v1_document_service, 4);

/**
 * Column reductions for single-value elements. Mirrors the client-side
 * aggregation set; the server computes them over the FULL backing artifact,
 * not the bounded preview.
 *
 * @generated from enum chalk.notebook.v1.NotebookDataframeAggregation
 */
export enum NotebookDataframeAggregation {
  /**
   * @generated from enum value: NOTEBOOK_DATAFRAME_AGGREGATION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: NOTEBOOK_DATAFRAME_AGGREGATION_MIN = 1;
   */
  MIN = 1,

  /**
   * @generated from enum value: NOTEBOOK_DATAFRAME_AGGREGATION_MAX = 2;
   */
  MAX = 2,

  /**
   * @generated from enum value: NOTEBOOK_DATAFRAME_AGGREGATION_MEAN = 3;
   */
  MEAN = 3,

  /**
   * @generated from enum value: NOTEBOOK_DATAFRAME_AGGREGATION_SUM = 4;
   */
  SUM = 4,

  /**
   * @generated from enum value: NOTEBOOK_DATAFRAME_AGGREGATION_MEDIAN = 5;
   */
  MEDIAN = 5,

  /**
   * @generated from enum value: NOTEBOOK_DATAFRAME_AGGREGATION_COUNT = 6;
   */
  COUNT = 6,

  /**
   * @generated from enum value: NOTEBOOK_DATAFRAME_AGGREGATION_COUNT_DISTINCT = 7;
   */
  COUNT_DISTINCT = 7,

  /**
   * Rank carried in AggregateNotebookDataframeRequest.percentile.
   *
   * @generated from enum value: NOTEBOOK_DATAFRAME_AGGREGATION_PERCENTILE = 8;
   */
  PERCENTILE = 8,

  /**
   * Population standard deviation.
   *
   * @generated from enum value: NOTEBOOK_DATAFRAME_AGGREGATION_STDDEV = 9;
   */
  STDDEV = 9,
}

/**
 * Describes the enum chalk.notebook.v1.NotebookDataframeAggregation.
 */
export const NotebookDataframeAggregationSchema: GenEnum<NotebookDataframeAggregation> = /*@__PURE__*/
  enumDesc(file_chalk_notebook_v1_document_service, 5);

/**
 * @generated from enum chalk.notebook.v1.NotebookDataframeDownloadFormat
 */
export enum NotebookDataframeDownloadFormat {
  /**
   * @generated from enum value: NOTEBOOK_DATAFRAME_DOWNLOAD_FORMAT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: NOTEBOOK_DATAFRAME_DOWNLOAD_FORMAT_CSV = 1;
   */
  CSV = 1,

  /**
   * @generated from enum value: NOTEBOOK_DATAFRAME_DOWNLOAD_FORMAT_ARROW_IPC = 2;
   */
  ARROW_IPC = 2,
}

/**
 * Describes the enum chalk.notebook.v1.NotebookDataframeDownloadFormat.
 */
export const NotebookDataframeDownloadFormatSchema: GenEnum<NotebookDataframeDownloadFormat> = /*@__PURE__*/
  enumDesc(file_chalk_notebook_v1_document_service, 6);

/**
 * Lifecycle of the kernel runtime (a chalk_nb_server container) that backs a
 * notebook document's python cell execution.
 *
 * @generated from enum chalk.notebook.v1.NotebookRuntimeState
 */
export enum NotebookRuntimeState {
  /**
   * @generated from enum value: NOTEBOOK_RUNTIME_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * No runtime row/container exists for this notebook.
   *
   * @generated from enum value: NOTEBOOK_RUNTIME_STATE_NONE = 1;
   */
  NONE = 1,

  /**
   * The container has been created but is not yet routable (no web URL).
   *
   * @generated from enum value: NOTEBOOK_RUNTIME_STATE_PROVISIONING = 2;
   */
  PROVISIONING = 2,

  /**
   * The container is routable; runs can reach the kernel.
   *
   * @generated from enum value: NOTEBOOK_RUNTIME_STATE_READY = 3;
   */
  READY = 3,

  /**
   * The container failed to provision or reports a failed status.
   *
   * @generated from enum value: NOTEBOOK_RUNTIME_STATE_ERROR = 4;
   */
  ERROR = 4,

  /**
   * The runtime row/container was explicitly stopped.
   *
   * @generated from enum value: NOTEBOOK_RUNTIME_STATE_STOPPED = 5;
   */
  STOPPED = 5,
}

/**
 * Describes the enum chalk.notebook.v1.NotebookRuntimeState.
 */
export const NotebookRuntimeStateSchema: GenEnum<NotebookRuntimeState> = /*@__PURE__*/
  enumDesc(file_chalk_notebook_v1_document_service, 7);

/**
 * @generated from service chalk.notebook.v1.NotebookDocumentService
 */
export const NotebookDocumentService: GenService<{
  /**
   * Mints a share link. The response carries the only copy of the secret URL.
   *
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.CreateNotebookShareLink
   */
  createNotebookShareLink: {
    methodKind: "unary";
    input: typeof CreateNotebookShareLinkRequestSchema;
    output: typeof CreateNotebookShareLinkResponseSchema;
  },
  /**
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.ListNotebookShareLinks
   */
  listNotebookShareLinks: {
    methodKind: "unary";
    input: typeof ListNotebookShareLinksRequestSchema;
    output: typeof ListNotebookShareLinksResponseSchema;
  },
  /**
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.RevokeNotebookShareLink
   */
  revokeNotebookShareLink: {
    methodKind: "unary";
    input: typeof RevokeNotebookShareLinkRequestSchema;
    output: typeof RevokeNotebookShareLinkResponseSchema;
  },
  /**
   * The share-link viewer's entry point: exchanges the token in the request
   * headers for the identity of the notebook it grants. Deliberately the only
   * way a holder learns that notebook id, which the read RPCs below then
   * require -- so a token never doubles as a way to enumerate the environment.
   *
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.ResolveNotebookShareLink
   */
  resolveNotebookShareLink: {
    methodKind: "unary";
    input: typeof ResolveNotebookShareLinkRequestSchema;
    output: typeof ResolveNotebookShareLinkResponseSchema;
  },
  /**
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.CreateNotebookComment
   */
  createNotebookComment: {
    methodKind: "unary";
    input: typeof CreateNotebookCommentRequestSchema;
    output: typeof CreateNotebookCommentResponseSchema;
  },
  /**
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.ListNotebookComments
   */
  listNotebookComments: {
    methodKind: "unary";
    input: typeof ListNotebookCommentsRequestSchema;
    output: typeof ListNotebookCommentsResponseSchema;
  },
  /**
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.DeleteNotebookComment
   */
  deleteNotebookComment: {
    methodKind: "unary";
    input: typeof DeleteNotebookCommentRequestSchema;
    output: typeof DeleteNotebookCommentResponseSchema;
  },
  /**
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.SetNotebookCommentResolved
   */
  setNotebookCommentResolved: {
    methodKind: "unary";
    input: typeof SetNotebookCommentResolvedRequestSchema;
    output: typeof SetNotebookCommentResolvedResponseSchema;
  },
  /**
   * Adds the caller's reaction with the given emoji, or removes it when the
   * caller already reacted with that emoji.
   *
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.ToggleNotebookCommentReaction
   */
  toggleNotebookCommentReaction: {
    methodKind: "unary";
    input: typeof ToggleNotebookCommentReactionRequestSchema;
    output: typeof ToggleNotebookCommentReactionResponseSchema;
  },
  /**
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.CreateNotebookDocument
   */
  createNotebookDocument: {
    methodKind: "unary";
    input: typeof CreateNotebookDocumentRequestSchema;
    output: typeof CreateNotebookDocumentResponseSchema;
  },
  /**
   * internal.resource_share_view is accepted alongside deploy.read and
   * notebook.write, so share-link holders use the signed-in read endpoint. The
   * permission only decides that a share token may call this RPC; the handler
   * is what confines it to the one notebook the token names.
   *
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.GetNotebookDocument
   */
  getNotebookDocument: {
    methodKind: "unary";
    input: typeof GetNotebookDocumentRequestSchema;
    output: typeof GetNotebookDocumentResponseSchema;
  },
  /**
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.ListNotebookDocuments
   */
  listNotebookDocuments: {
    methodKind: "unary";
    input: typeof ListNotebookDocumentsRequestSchema;
    output: typeof ListNotebookDocumentsResponseSchema;
  },
  /**
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.UpdateNotebookDocument
   */
  updateNotebookDocument: {
    methodKind: "unary";
    input: typeof UpdateNotebookDocumentRequestSchema;
    output: typeof UpdateNotebookDocumentResponseSchema;
  },
  /**
   * Returns the id of the Dashboard row backing this notebook's app view,
   * creating it (empty, owner_type="notebook") and linking it to the document
   * in one transaction on first call. Idempotent.
   *
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.EnsureNotebookApp
   */
  ensureNotebookApp: {
    methodKind: "unary";
    input: typeof EnsureNotebookAppRequestSchema;
    output: typeof EnsureNotebookAppResponseSchema;
  },
  /**
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.DeleteNotebookDocument
   */
  deleteNotebookDocument: {
    methodKind: "unary";
    input: typeof DeleteNotebookDocumentRequestSchema;
    output: typeof DeleteNotebookDocumentResponseSchema;
  },
  /**
   * Archives or restores a notebook by setting/clearing archived_at. Archived
   * notebooks are excluded from the default list (ListNotebookDocuments with
   * include_archived=false) but are not soft-deleted.
   *
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.SetNotebookArchived
   */
  setNotebookArchived: {
    methodKind: "unary";
    input: typeof SetNotebookArchivedRequestSchema;
    output: typeof SetNotebookArchivedResponseSchema;
  },
  /**
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.AddNotebookCell
   */
  addNotebookCell: {
    methodKind: "unary";
    input: typeof AddNotebookCellRequestSchema;
    output: typeof AddNotebookCellResponseSchema;
  },
  /**
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.UpdateNotebookCell
   */
  updateNotebookCell: {
    methodKind: "unary";
    input: typeof UpdateNotebookCellRequestSchema;
    output: typeof UpdateNotebookCellResponseSchema;
  },
  /**
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.DeleteNotebookCell
   */
  deleteNotebookCell: {
    methodKind: "unary";
    input: typeof DeleteNotebookCellRequestSchema;
    output: typeof DeleteNotebookCellResponseSchema;
  },
  /**
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.MoveNotebookCell
   */
  moveNotebookCell: {
    methodKind: "unary";
    input: typeof MoveNotebookCellRequestSchema;
    output: typeof MoveNotebookCellResponseSchema;
  },
  /**
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.BatchUpdateNotebookCells
   */
  batchUpdateNotebookCells: {
    methodKind: "unary";
    input: typeof BatchUpdateNotebookCellsRequestSchema;
    output: typeof BatchUpdateNotebookCellsResponseSchema;
  },
  /**
   * Persists the run plan and launches execution server-side; execution is
   * not tied to any client connection. Observe progress via WatchNotebookRun.
   *
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.StartNotebookRun
   */
  startNotebookRun: {
    methodKind: "unary";
    input: typeof StartNotebookRunRequestSchema;
    output: typeof StartNotebookRunResponseSchema;
  },
  /**
   * Replays persisted events for the run, then tails live events until the
   * run reaches a terminal state. Safe to call repeatedly and from multiple
   * clients; reconnect with after_sequence to skip already-seen output.
   *
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.WatchNotebookRun
   */
  watchNotebookRun: {
    methodKind: "server_streaming";
    input: typeof WatchNotebookRunRequestSchema;
    output: typeof WatchNotebookRunResponseSchema;
  },
  /**
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.WatchNotebook
   */
  watchNotebook: {
    methodKind: "server_streaming";
    input: typeof WatchNotebookRequestSchema;
    output: typeof WatchNotebookResponseSchema;
  },
  /**
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.InterruptNotebookRun
   */
  interruptNotebookRun: {
    methodKind: "unary";
    input: typeof InterruptNotebookRunRequestSchema;
    output: typeof InterruptNotebookRunResponseSchema;
  },
  /**
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.ListNotebookCellResults
   */
  listNotebookCellResults: {
    methodKind: "unary";
    input: typeof ListNotebookCellResultsRequestSchema;
    output: typeof ListNotebookCellResultsResponseSchema;
  },
  /**
   * Pages through the full data behind a dataframe output chunk (blob-backed
   * Arrow artifacts, inline previews, SQL results), beyond the persisted
   * preview rows.
   *
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.FetchNotebookDataframeRows
   */
  fetchNotebookDataframeRows: {
    methodKind: "unary";
    input: typeof FetchNotebookDataframeRowsRequestSchema;
    output: typeof FetchNotebookDataframeRowsResponseSchema;
  },
  /**
   * Reduces one column of a dataframe output chunk to a single value over the
   * FULL backing artifact (blob-backed Arrow, inline arrow bytes) — used by
   * single-value elements whose source is larger than the persisted preview.
   *
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.AggregateNotebookDataframe
   */
  aggregateNotebookDataframe: {
    methodKind: "unary";
    input: typeof AggregateNotebookDataframeRequestSchema;
    output: typeof AggregateNotebookDataframeResponseSchema;
  },
  /**
   * Streams the complete dataframe behind an output chunk for download —
   * the full backing data, never just the preview rows.
   *
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.DownloadNotebookDataframe
   */
  downloadNotebookDataframe: {
    methodKind: "server_streaming";
    input: typeof DownloadNotebookDataframeRequestSchema;
    output: typeof DownloadNotebookDataframeResponseSchema;
  },
  /**
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.ListNotebookCellRunHistory
   */
  listNotebookCellRunHistory: {
    methodKind: "unary";
    input: typeof ListNotebookCellRunHistoryRequestSchema;
    output: typeof ListNotebookCellRunHistoryResponseSchema;
  },
  /**
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.ListNotebookDocumentRevisions
   */
  listNotebookDocumentRevisions: {
    methodKind: "unary";
    input: typeof ListNotebookDocumentRevisionsRequestSchema;
    output: typeof ListNotebookDocumentRevisionsResponseSchema;
  },
  /**
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.ListNotebookRuns
   */
  listNotebookRuns: {
    methodKind: "unary";
    input: typeof ListNotebookRunsRequestSchema;
    output: typeof ListNotebookRunsResponseSchema;
  },
  /**
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.GetNotebookRunDetails
   */
  getNotebookRunDetails: {
    methodKind: "unary";
    input: typeof GetNotebookRunDetailsRequestSchema;
    output: typeof GetNotebookRunDetailsResponseSchema;
  },
  /**
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.ClearNotebookCellResults
   */
  clearNotebookCellResults: {
    methodKind: "unary";
    input: typeof ClearNotebookCellResultsRequestSchema;
    output: typeof ClearNotebookCellResultsResponseSchema;
  },
  /**
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.GetNotebookSqlCacheSettings
   */
  getNotebookSqlCacheSettings: {
    methodKind: "unary";
    input: typeof GetNotebookSqlCacheSettingsRequestSchema;
    output: typeof GetNotebookSqlCacheSettingsResponseSchema;
  },
  /**
   * Environment-wide cache policy is the admin knob; notebook/cell overrides
   * ride UpdateNotebookDocument/UpdateNotebookCell at editor tier.
   *
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.UpdateNotebookSqlCacheSettings
   */
  updateNotebookSqlCacheSettings: {
    methodKind: "unary";
    input: typeof UpdateNotebookSqlCacheSettingsRequestSchema;
    output: typeof UpdateNotebookSqlCacheSettingsResponseSchema;
  },
  /**
   * Provisions (or returns the existing) kernel runtime for a notebook: a
   * notebooks runtime row plus a chalk_nb_server container bound to this
   * notebook's session id. Idempotent — a second call returns the current
   * status without creating a duplicate container. Container creation is
   * synchronous but readiness (a routable web URL) is asynchronous, so a fresh
   * provision returns PROVISIONING and callers poll GetNotebookRuntimeStatus.
   *
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.StartNotebookRuntime
   */
  startNotebookRuntime: {
    methodKind: "unary";
    input: typeof StartNotebookRuntimeRequestSchema;
    output: typeof StartNotebookRuntimeResponseSchema;
  },
  /**
   * Stops the runtime container and marks the notebooks row stopped. Idempotent.
   *
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.StopNotebookRuntime
   */
  stopNotebookRuntime: {
    methodKind: "unary";
    input: typeof StopNotebookRuntimeRequestSchema;
    output: typeof StopNotebookRuntimeResponseSchema;
  },
  /**
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.GetNotebookRuntimeStatus
   */
  getNotebookRuntimeStatus: {
    methodKind: "unary";
    input: typeof GetNotebookRuntimeStatusRequestSchema;
    output: typeof GetNotebookRuntimeStatusResponseSchema;
  },
  /**
   * Streams the notebook's kernel runtime status: sends the current status
   * immediately on subscribe, then a new message each time the derived state
   * (or its error detail / web-url presence) changes, until the client
   * disconnects. Backend-owned readiness the frontend subscribes to instead of
   * polling GetNotebookRuntimeStatus, so kernel-dependent queries can gate on a
   * READY state rather than racing a booting kernel.
   *
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.WatchNotebookRuntimeStatus
   */
  watchNotebookRuntimeStatus: {
    methodKind: "server_streaming";
    input: typeof WatchNotebookRuntimeStatusRequestSchema;
    output: typeof WatchNotebookRuntimeStatusResponseSchema;
  },
  /**
   * Lists live kernel runtimes (non-stopped notebooks with a non-stopped
   * backing container) in the request's environment. State is resolved per row
   * the same way GetNotebookRuntimeStatus resolves it for a single notebook.
   *
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.ListNotebookRuntimes
   */
  listNotebookRuntimes: {
    methodKind: "unary";
    input: typeof ListNotebookRuntimesRequestSchema;
    output: typeof ListNotebookRuntimesResponseSchema;
  },
  /**
   * Lists the Python packages installed in a notebook's running kernel by
   * proxying to the kernel's ListInstalledPackages RPC (cached per container).
   *
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.ListNotebookKernelPackages
   */
  listNotebookKernelPackages: {
    methodKind: "unary";
    input: typeof ListNotebookKernelPackagesRequestSchema;
    output: typeof ListNotebookKernelPackagesResponseSchema;
  },
  /**
   * Assembles the notebook's variable data-flow DAG: nodes are runnable cells,
   * edges are last-producer-wins dependencies. Provides/requires come from the
   * kernel's AST analysis (AnalyzeNotebookCellDependencies), not a server-side
   * line parser. Returns an empty graph when no kernel runtime is reachable.
   *
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.GetNotebookDependencyGraph
   */
  getNotebookDependencyGraph: {
    methodKind: "unary";
    input: typeof GetNotebookDependencyGraphRequestSchema;
    output: typeof GetNotebookDependencyGraphResponseSchema;
  },
  /**
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.ListNotebookSecrets
   */
  listNotebookSecrets: {
    methodKind: "unary";
    input: typeof ListNotebookSecretsRequestSchema;
    output: typeof ListNotebookSecretsResponseSchema;
  },
  /**
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.GetNotebookSecretValue
   */
  getNotebookSecretValue: {
    methodKind: "unary";
    input: typeof GetNotebookSecretValueRequestSchema;
    output: typeof GetNotebookSecretValueResponseSchema;
  },
  /**
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.UpsertNotebookSecret
   */
  upsertNotebookSecret: {
    methodKind: "unary";
    input: typeof UpsertNotebookSecretRequestSchema;
    output: typeof UpsertNotebookSecretResponseSchema;
  },
  /**
   * @generated from rpc chalk.notebook.v1.NotebookDocumentService.DeleteNotebookSecret
   */
  deleteNotebookSecret: {
    methodKind: "unary";
    input: typeof DeleteNotebookSecretRequestSchema;
    output: typeof DeleteNotebookSecretResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_chalk_notebook_v1_document_service, 0);

